export default {
  es: {
    auth: {
      clientNumber: 'Número de cliente',
      curp: 'CURP',
      accountNumber: 'No. de cuenta',
      EMAIL_VERIFICATION: 'email',
      SMS_VERIFICATION: 'sms',
      EMAIL: 'EMAIL',
      SMS: 'SMS',
      email: 'Correo electrónico',
      login: {
        hiAgain: '¡Hola de nuevo! {name}',
        connect: 'Conectarse',
        oneAccount: 'Una única cuenta para todos los servicios',
        clientNumber: 'Número de cliente',
        password: 'Contraseña',
        access: 'Acceder',
        forgotPassword: '¿Has olvidado la contraseña?',
        dontHaveAccount: '¿Aun no tienes cuenta? ¡Regístrate aquí!',
        createAccount: '¡Créala ahora!',
        accessBiometric: 'Acceder con biometría',
        accessWithUser: 'Acceder con usuario y contraseña',
        activateBiometric: '¿Quieres activar la biometría?',
        activateBiometricDescription: 'Los próximos accesos a la app serán mas rapidos y seguros',
        activateBiometricSuccess: 'Biometría activada con éxito, puedes cambiar esta preferencia desde ajustes en tu cuenta',
        activate: 'Activar',
        biometricError: 'Ha ocurrido un error al intentar acceder con biometría, por favor inicia sesión con tu usuario y contraseña',
        biometricUnavailable: 'La biometría no está disponible en el dispositivo',
        goToLogin: 'Ir a login',
        imAClient: 'Soy cliente',
        beNewClient: 'Hazte cliente',
        USER_HAS_AN_ACTIVE_SESSION: 'Detectamos una sesión activa asociada a tu cuenta. Para ingresar, finaliza la sesión actual e inténtalo nuevamente.',
      },
      recoverPassword: {
        restorePassword: 'Restablecer contraseña',
        enterFields: 'Selecciona si quieres buscar tu cuenta con tu email o teléfono, y te mandaremos un link para poder configurar tu contraseña de nuevo.',
        restore: 'Restablecer',
        successTitle: 'Solicitud realizada',
        successDescription: 'Si la cuenta existe en breve recibirás un enlace para que puedas restablecer tu contraseña.',
        errorDescription: 'Ha ocurrido un error, por favor revisa los datos e intenta de nuevo',
      },
      resetPassword: {
        title: 'Establecer nueva contraseña',
        createPassword: 'Crear Contraseña',
        newPassword: 'Confirmar Contraseña',
        errorDescription: 'Ha ocurrido un error, por favor revisa los datos e intenta de nuevo',
        successDescription: 'Tu contraseña ha sido creada con éxito',
        passwordRules: {
          length: 'Mínimo 8 caracteres y máximo 15',
          capitalAndLowercaseLetter: 'Al menos una letra mayúscula y una minúscula',
          number: 'Al menos un número',
          specialCharacter: 'Al menos un carácter especial (@,#,$,%..)',
          equal: 'Las contraseñas deben coincidir',
        },
        errorEqualLast: 'La contraseña nueva no puede ser igual a las 5 contraseñas anteriores',
        errorInvalidToken: 'El enlace para crear la contraseña ha caducado, por favor solicita uno nuevo',
        errorLengthNumber: 'La contraseña debe tener entre {minLength} y {maxLength} caracteres',
        errorLength: 'La contraseña no cumple con los requisitos de longitud, revisa los campos y vuelve a intentarlo',
      },
      otpModal: {
        title: 'Asocia tu cuenta',
        info: 'Introduce el código de {length} caracteres que has recibido por {type} para continuar con el registro.',
        introduceCode: 'Introduce el código',
        codeNotReceived: '',
      },
    },
    sessionClosed: {
      title: 'Sesión terminada',
      description: 'Tu sesión ha caducado, por favor inicia sesión de nuevo',
      goToLogin: 'Ir al login',
    },
    inactiveSession: {
      title: 'Sesión cerrada',
      description: 'Tu sesión se ha cerrado por inactividad, por favor inicia sesión de nuevo',
      goToLogin: 'Ir al login',
    },
    layout: {
      rightMenu: {
        client: 'Cliente: {number}',
        home: 'Inicio',
        settings: 'Ajustes',
        profile: 'Mi perfil',
        documents: 'Documentos',
        discoverApp: 'Descubre la app',
        modifyPassword: 'Modificar\ncontraseña',
        onlinePayment: 'Pago en línea',
        who: 'Quiénes somos',
        privacyPolicy: 'Política de\nprivacidad',
        logout: 'Cerrar sesión',
        finsus: 'Finsus',
        appointment: 'Cita',
        associate: 'Asociar cliente',
        interbankKey: 'CLABE: {number}',
        payments: 'Pago en linea',
        reprintingReceipts: 'Reimpresión de comprobantes',
        estadoPagos: 'Historico de pagos',
        myCoupons: 'Mis cupones',
        referrals: 'Programa de referidos',
        notifications: 'Notificaciones',
        backToSite: 'Volver al sitio',
        termsAndConditions: 'Términos y Condiciones',
      },
    },
    bottomMenu: {
      home: 'Home',
      billing: 'Facturación',
      stores: 'Tiendas',
      help: 'Asistencia',
    },
    home: {
      welcome: '¡Bienvenido',
      logout: 'Cerrar sesión',
      registerOrAccess: 'Registro / Acceso',
      guestUser: 'Usuario invitado',
      completeProfile: 'Termina tu registro',
      completeProfileDescription: 'Completa los datos de tu perfil para acceder a todas las ventajas de MLS App',
      digitalLoanBanner: {
        newTitle: 'Préstamo de Cercanía',
        newSubtitle: 'Aprovecha tu cercanía con nosotros',
        newCta: 'Conoce requisitos',
        activeTitle: 'Préstamo inmediato',
        activeStatus: 'En proceso',
        activeCta: 'Ver solicitud',
        heroAlt: 'Préstamo de cercanía',
      },
      digitalLoanInProgress: {
        title: 'Préstamo inmediato',
        status: 'En proceso',
        viewRequest: 'Ver solicitud',
        heroAlt: 'Préstamo de cercanía',
      },
      digitalLoanContractReady: {
        title: 'Préstamo inmediato',
        status: 'Contrato listo',
        viewRequest: 'Ver solicitud',
        heroAlt: 'Contrato de préstamo listo',
      },
      call: 'Llamar',
      schedule: 'Agendar una cita',
      usernearbyShops: 'Sucursales cercanas a tu ubicación:',
      nearbyShops: 'Sucursales cercanas:',
      shopNear1: '¡Tienes una',
      shopNear2: 'sucursal MLS',
      shopNear3: 'cerca de ti!',
      details: 'Detalle',
      yourContractsAndSections: 'Tus contratos y apartados',
      storesNotFound: 'Vaya, parece que no hay tiendas cerca de ti',
      goToStores: 'Ir al buscador',
      yourContracts: 'Tus contratos',
      yourSections: 'Tus apartados',
      numActiveContracts: 'Tienes activos:',
      showAll: 'ver todo',
      contracts: 'Contratos',
      sections: 'Apartados',
      loans: {
        title: 'Préstamos',
        viewAll: 'ver todo',
        loanWarranty: 'Préstamo con garantía de auto',
        driveDreams: '¡Conduce hacia tus sueños!',
        simulateLoan: 'Simula tu préstamo',
        transformJewelry: 'Transforma tus joyas en oportunidades',
        offers: 'Ofertas de confianza',
        quoteJewelry: 'Cotizas tu joyas',
        executiveDriver: 'Conductor ejecutivo',
        uberDriver: '¿Ya eres conductor de UBER?',
        offerForYou: '¡Tenemos una oferta para ti!',
        info: 'Infórmate aquí',
      },
      shopping: {
        title: 'Compras',
        viewAll: 'ver todo',
        onlineStore: 'Tienda en línea',
        smartShopping: 'Compras inteligentes, Satisfacción Total',
        visitStore: 'Visita la tienda',
        auctions: 'Subastas',
        excitingBids: 'Pujas emocionantes, Precios Increíbles',
        discoverYourAuctions: 'Descubre tus subastas',
        auction: 'Subasta',
        online: 'Online',
        register: 'Registrarse para ofertar',
        catalog: 'Catálogo',
      },
      oportunities: {
        title: 'Oportunidades',
        viewAll: 'ver todo',
        oneAccount: 'Una cuenta para todo',
        payOnline: 'Ingresa y paga tus plazos 100% online',
        openMyAccount: 'Abre mi cuenta',
      },
    },
    automaticQuoter: {
      title: 'Cotizador automático',
      subtitle: 'Aquí podrás hacerle una fotografía al objeto que quieras empeñar para comenzar el proceso de tasación. Los objetos que puedes empeñar incluyen:',
      cars: 'Auto, toma una foto del frontal.',
      watches: 'Relojes.',
      jewelry: 'Alhajas.',
      diamonds: 'Diamantes.',
      camera: 'Cámara',
      takePhoto: 'Toma una foto del producto que quieres cotizar',
      takePhotoCars: 'Toma una foto del auto que quieres cotizar',
      takePhotoDiamonds: 'Toma una foto del diamante que quieres cotizar',
      takePhotoWatches: 'Toma una foto del reloj que quieres cotizar',
      takePhotoJewelry: 'Toma una foto de la joya que quieres cotizar',
      cameraPermissionDenied: 'No has permitido el acceso a la cámara, por favor, permite el acceso para continuar',
      cameraPermissionPending: 'Esperando permisos para acceder a la cámara',
      errorIdentifyingPhoto: 'No hemos detectado autos, alhajas, diamantes o relojes.\n\n Puedes volver a intentarlo.',
      vehucleIdentified: 'Vehículo identificado',
      watchIdentified: 'Reloj identificado',
      jewelryIdentified: 'Joya identificada',
      diamondIdentified: 'Diamante identificado',
      brand: 'Marca',
      model: 'Modelo',
      version: 'Versión',
      year: 'Año',
      scanningImage: 'Escaneando imagen, esta operación puede tardar hasta un minuto',
      otherIdentified: '¡OTHER_SUBTYPE identificado!',
      otherIdentifiedSubtype: 'Hemos identicado que quieres empeñar un objeto de tipo <strong>"OTHER_SUBTYPE"</strong>',
      otherIdentifiedBrand: ' de la marca <strong>OTHER_BRAND</strong>',
      otherIdentifiedModel: ' y modelo <strong>OTHER_MODEL</strong>',
      otherIdentifiedInfo: 'Actualmente no contamos con un cotizador para este tipo de producto, pero puedes acudir a una de nuestras sucursales para que nuestros expertos te ayuden a cotizarlo.',
      searchStore: 'Buscar tienda',
      infoStorageImages: 'El uso de la cámara es únicamente para el escaneo de productos que son susceptibles de empeño. La app no guardará ninguna imagen capturada por la camara.',
    },
    quoter: {
      title: '¿Prefieres cotizar otra cosa?',
      loanAmount: 'Monto del préstamo',
      createAppointment: 'Agendar cita',
      contactForm: 'Formulario de contacto',
      probableLoanRange: 'Rango probable de préstamo',
      terms: 'Plazos',
      maxLoan: 'Préstamo máx.',
      minLoan: 'Préstamo mín.',
      repeatQuote: 'Volver a cotizar',
      threeMonths: '3 meses',
      sixMonths: '6 meses',
      monthly: 'Mensual',
      errorTitle: 'Ha ocurrido un error',
      errorQuotes: 'No hemos podido realizar la cotización, por favor revisa los datos e intentalo de nuevo',
      errorDescription: 'No hemos podido realizar la cotización, por favor revisa los datos e intentalo de nuevo',
      jewelry: {
        title: 'Cotizador de alhajas',
        info: 'Selecciona el kilataje de su prenda e ingrese el peso aproximado del metal:',
        carats: 'Kilataje',
        weightInGrams: 'Peso en gramos',
        weight: 'Peso',
        getQuote: 'COTIZAR ALHAJA',
      },
      cars: {
        title: 'Cotizador de autos',
        info: 'Selecciona las características del auto:',
        year: 'Año',
        brand: 'Marca',
        model: 'Modelo',
        version: 'Versión',
        product: 'Producto',
        getQuote: 'COTIZAR AUTO',
        saveCar: 'Me lo guardan',
        takeCar: 'Me lo llevo',
        information: 'Información',
        store: 'Sucursal',
        quoter: 'Cotizador',
        loanInfo: 'Obtén tu <strong>préstamo inmediato</strong> en Montepío Luz Saviñón, con las condiciones más ventajosas del mercado.',
        loanBenefit1: '<strong>Síguelo manejando</strong> o déjalo en resguardo.',
        loanBenefit2: 'Monto de préstamo de <strong>hasta el 80%</strong> por la factura de tu auto.',
        loanBenefit3: 'Cómodos plazos.',
        loanBenefit4: 'Solo <strong>paga el tiempo que ocupes.</strong>',
        loanBenefit5: 'Puedes <strong>abonar a capital</strong> sin pagar intereses adicionales o de atraso.',
        biweeklypayment: 'Pago quincenal',
        monthlyTerm: 'Plazo (quincenas)',
        minAmount: 'El monto mínimo es de {amount}',
        maxAmount: 'El monto máximo es de {amount}',
      },
      watches: {
        title: 'Cotizador de relojes',
        info: 'Selecciona las características del reloj:',
        brand: 'Marca',
        model: 'Modelo',
        averagePrice: 'Precio promedio de su reloj',
        status: 'Estado',
        statusList: {
          new: 'Como nuevo',
          good: 'Buen estado',
          used: 'Bastante usado',
        },
        getQuote: 'COTIZAR RELOJ',
      },
      diamonds: {
        title: 'Cotizador de diamantes',
        info: 'Selecciona las características del diamante:',
        weightInGrams: 'Peso en gramos',
        weightInCarats: 'Peso en kilates',
        amount: 'Cantidad',
        getQuote: 'COTIZAR DIAMANTE',
        weight: 'Peso',
        diamondColor: 'Color del diamante',
        color: 'Color',
        purity: 'Pureza',
        diamondCut: 'Talla',
        cuts: {
          brilliant: 'Brillante',
          esmerald: 'Esmeralda',
          pear: 'Pera',
          marquise: 'Marquesa',
          heart: 'Corazón',
          asscher: 'Asscher',
          oval: 'Oval',
          radiant: 'Radiante',
          princess: 'Princesa',
        },
      },
    },
    quotes: {
      cars: {
        title: 'Cotizador de Autos',
        description: 'Encuentra los mejores productos y págalos en cómodos plazos sin intereses',
      },
      diamonds: {
        title: 'Cotizador de Diamantes',
        description: 'Encuentra los mejores productos y págalos en cómodos plazos sin intereses',
      },
      watches: {
        title: 'Cotizador de Relojes',
        description: 'Encuentra los mejores productos y págalos en cómodos plazos sin intereses',
      },
      executiveDriver: {
        title: 'Conductor Ejecutivo',
        description: 'Encuentra los mejores productos y págalos en cómodos plazos sin intereses',
      },
      jewelry: {
        title: 'Cotizador de Alhajas',
        description: 'Encuentra los mejores productos y págalos en cómodos plazos sin intereses',
      },
    },
    services: {
      title: 'Todas las opciones',
      loans: 'Préstamos',
      shopping: 'Compras',
      opportinities: 'Oportunidades',
    },
    billing: {
      title: 'Facturación',
      billingPortal: 'Portal de facturación',
      fillInputs: 'Ingresa los datos solicitados',
      contractPayment: 'Pago de contrato',
      sellNote: 'Nota de venta',
      contractSection: 'Contrato de apartado',
      operationType: 'Tipo de operación',
      folioNumber: 'Folio de venta',
      operationDate: 'Fecha de operación',
      amount: 'Monto',
      officeNumber: 'Número de sucursal',
    },
    onboarding: {
      initSession: 'Iniciar sesión',
    },
    settings: {
      language: 'Idioma',
      spanish: 'Español',
      english: 'Inglés',
      notifications: 'Notificaciones',
      biometricAccess: 'Acceso biométricos',
      enabled: 'Activado',
      disabled: 'Desactivado',
      faceIdAccess: 'Acceso con biometría',
      faceIdEnabled: 'Biometría Activada',
      faceIdDisabled: 'Biometría Desactivado',
      faceIDSuccess: 'Acceso con Biometría activado con éxito',
      faceIDError: 'Ha ocurrido un error al activar la biometria, intentelo de nuevo.',
      currentlyRegisteredFaceId: 'Actualmente tienes registrado el Face ID',
      disableFaceId: 'DESACTIVAR BIOMETRÍA',
      enableFaceId: 'ACTIVAR BIOMETRÍA',
      unavailable: 'No disponible',
      deleteFaceId: 'Borrar Face ID',
      modifyMlsPassword: 'Modificar contraseña MLS',
      modifyPassword: 'Modificar contraseña',
      enterFollowingData: 'Introduce los siguientes datos',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Repite la nueva contraseña',
      confirm: 'CONFIRMAR',
      passwordSaved: 'Tu contraseña ha sido guardada con éxito',
      wrongPassword: 'La contraseña actual es incorrecta',
      genericError: 'Ha ocurrido un error, por favor intenta de nuevo',
      appVersion: 'Versión app',
      version: 'Versión',
      sapAssociate: 'Cliente de Montepío',
      notAssociated: 'No asociado',
      isAssociated: 'Tu cuenta de la app está asociada a un cliente de Montepío',
      isNotAssociated: 'Tu cuenta de la app no está asociada a un cliente de Montepío',
      queryParams: 'Parámetros de la URL',
      logs: 'Logs',
      operatingSystemVersion: 'Versión del sistema operativo',
      clientNumber: 'Número de cliente',
      inputClientNumber: 'Introduce el número de cliente que quieres asociar con esta cuenta',
      sap: {
        successTitle: 'Usuario asociado correctamente',
        successDescription: '',
        errorSendOtp: 'No se ha podido enviar el código de verificación',
        errorSendOtpDescription: 'Compruebe el número de cliente e inténtelo de nuevo',
        errorTitle: 'No se ha podido asociar el usuario',
        errorDescription: 'Compruebe el número de 4 dígitos e inténtelo de nuevo',
        unlinkSAP: 'Desvincular cliente Montepío',
        unlinkDescription: '¿Estás seguro de que deseas desvincular tu cuenta de cliente con la app?',
        unlinkSuccessTitle: 'Desvinculación exitosa',
        unlinkSuccessDescription: 'Tu cuenta de cliente ha sido desvinculada con éxito',
        unlinkErrorTitle: 'Error al desvincular',
        unlinkErrorDescription: 'Ha ocurrido un error al desvincular tu cuenta de cliente con la app, por favor intenta de nuevo',
      },
      pushNotifications: 'Notificaciones',
      disableNotifications: 'Desactivar notificaciones',
      enableNotifications: 'Activar notificaciones',
      notificationsNotAvailable: 'Las notificaciones no están disponibles, revisa si has bloqueado las notificaciones en los ajustes del dispositivo',
      notificationsOtherUser: 'Para poder desactivar las notificaciones debes iniciar sesion con el usuario que las activo',
    },
    stores: {
      title: 'Sucursales y Tiendas',
      search: 'Buscar sucursales y tiendas',
      addressSearch: 'Dirección, Sucursal o C.P.',
      shop: 'Sucursal',
      shopAddress: 'Dirección de sucursal',
      contactNumber: 'Número de contacto',
      timetable: 'Horario',
      scheduleTime: 'L-V {weekly}\nS {weekend}',
      yoCan: 'Podrás empeñar',
      call: 'Llamar',
      scheduleAppointment: 'Agendar una cita',
      appointmentSuccess: 'Cita exitosa',
      appointmentDate: 'Fecha de la cita',
      schedule: 'Agendar',
      selectOther: 'Seleccionar otra sucursal',
      searchOther: 'Buscar otra sucursal',
    },
    documents: {
      contracts: 'Contratos',
      accountStatements: 'Estados de cuenta',
    },
    digitalization: {
      title: 'Historico de pagos',
      search: 'Buscar',
      searchPlaceholder: 'Buscar por número, fecha o ramo',
      filterPlaceholder: 'Filtrar por estado',
      filterHelptext: 'Selecciona un filtro para ver resultados específicos',
      contracts: 'Contratos',
      bazar: 'Apartados/Ventas',
      apartados: 'Apartados',
      reprint: 'Reimprimir',
      reprintShort: 'Comprobante',
      selectDocument: 'Seleccionar documento',
      document: 'Documento',
      documentId: 'ID',
      download: 'Descargar',
      loading: 'Cargando...',
      loadingDocument: 'Cargando documento...',
      back: 'Volver',
      paymentsHistory: 'Historial de pagos',
      close: 'Cerrar',
      active: 'Activo',
      errorLoadData: 'Ha ocurrido un error al cargar los datos, intentalo de nuevo más tarde',
      errorLoadDocument: 'No se pudo obtener el documento, verifica e intentalo de nuevo',
      noContractsFound: 'No se encontraron comprobantes para ese criterio',
      noContracts: 'No tienes comprobantes disponibles para reimprimir',
      noSalesFound: 'No se encontraron comprobantes para ese criterio',
      noSales: 'No tienes comprobantes disponibles para reimprimir',
      noSectionsFound: 'No se encontraron comprobantes para ese criterio',
      noSections: 'No tienes comprobantes disponibles para reimprimir',
      noDocumentsAvailable: 'No hay documentos disponibles para reimprimir',
      noPaymentsHistory: 'Sin historial de pagos',
      salesProducts: 'Productos de la venta',
      noProducts: 'Sin productos',
      qty: 'Cant.',
      digitalized: 'Digitalizado',
      notDigitalized: 'No digitalizado',
      downloadDigitalizedDocument: 'Descargar contrato digitalizado',
      saleNote: 'Nota de venta',
      section: 'Apartado',
      cancelled: 'Cancelado',
      invalidContractFormat: 'El número de contrato debe tener 16 caracteres (13 del contrato + _ + 2 del identificador)',
      invalidSectionFormat: 'El número de apartado debe tener 6 caracteres',
      invalidSaleNoteFormat: 'La nota de venta debe tener 7 caracteres numéricos',
      contractLabel: 'Contrato',
      branchLabel: 'Sucursal',
      dateLabel: 'Fecha de creación',
      paymentDateLabel: 'Fecha de pago',
      amountLabel: 'Monto',
      loanLabel: 'Préstamo',
      totalLabel: 'Total',
      typeLabel: 'Tipo',
      movementLabel: 'Movimiento',
      sectionLabel: 'Apartado',
      cajaLiteralsLabel: 'Caja',
      ramoLiteralsLabel: 'Ramo',
      productsLabel: 'Productos',
      nvLabel: 'NV',
    },
    payments: {
      title: 'Pago en línea',
      reprintingReceipts: 'Reimpresión de comprobantes',
      contracts: 'Contratos',
      sections: 'Apartados',
      hideSection: 'Ocultar',
      contractOrSection: 'Contrato/Apartado',
      upcomingExpirations: 'Próximos vencimientos',
      contract: 'Contrato',
      nextExpiration: 'Vencimiento:',
      pay: 'Realizar pago',
      multiplePayment: 'Pago múltiple',
      noContracts: 'No tienes contratos',
      noSections: 'No tienes apartados',
      noContractsFound: 'No se han encontrado contratos',
      noSectionsFound: 'No se han encontrado apartados',
      sectionProducts: '({number} productos)',
      loadingRedirect: 'Un momento...',
      redirectError: 'Se ha producido un error, cierra esta ventana y vuelve a la app para intentarlo de nuevo',
      closeWindow: 'Cierra esta ventana y vuelve a la app',
      errorLoadData: 'Ha ocurrido un error al cargar los datos, intentalo de nuevo más tarde',
    },
    loyaltyPoints: {
      yourLoyaltyPoints: 'Tus puntos de lealtad',
      unusedPoints: 'Saldo por ocupar:',
      numberPoints: '{points} puntos',
      welcomeBonus: 'Bono de bienvenida acumulado: {points} puntos',
      clientNumber: 'Número de cliente:',
      clientNumberNumber: 'Número de cliente: {number}',
      couponHistory: 'Histórico de cupones',
      promotions: 'Promociones',
      currentPromotions: 'Promociones vigentes',
      coupon: 'Cupón',
      pointsToUse: 'Puntos a descontar:',
      pointsUsed: 'Puntos usados:',
      discount: 'Descuento:',
      discountOnSale: 'Descuento sobre el total de la venta:',
      discountOnInterest: 'Descuento sobre el pago total del interés:',
      maxInterestDiscount: 'Monto máximo del descuento sobre interés:',
      applyIn: 'Aplica en:',
      applyInPurchases: 'Aplica en compras de:',
      applyInInterest: 'Aplica en pago de interés de:',
      couponType: 'Tipo de cupón:',
      legacyCouponType: 'Comercialización',
      life: 'Vigencia:',
      maxAmount: 'Monto máximo:',
      createCoupon: 'Crear cupón',
      couponId: 'ID del cupón:',
      couponClientId: 'ID cupón cliente:',
      notEnoughPoints: 'Puntos insuficientes',
      sections: {
        WATCHES: 'Relojes',
        JEWELRY: 'Alhajas',
        OTHERS: 'Varios',
        AUTOS: 'Autos',
      },
      goToCoupon: 'Ver el cupón',
      usedPromotions: 'Promociones canjeadas',
      confirmCreateCoupon: '¿Estás seguro de que deseas usar <b>{points} puntos</b> para obtener el cupón "{description}"?\n\n Tu nuevo saldo será de <b>{newPoints} puntos</b>',
      noPromotions: 'No tienes ninguna disponible, pronto sacaremos nuevas promociones',
      couponCreated: '¡Cupón creado!',
      couponsActive: 'Vigentes',
      couponsUsed: 'Canjeados',
      couponsExpired: 'Vencidos',
      noCoupons: {
        1: 'No tienes ningún cupón vigente',
        2: 'No tienes ningún cupón canjeado',
        3: 'No tienes ningún cupón vencido',
      },
      viewPromotions: 'Ver promociones',
      couponUsed: 'El cupón ya ha sido canjeado',
      couponExpired: 'El cupón ya ha vencido',
      errorLoadPoints: 'Ha ocurrido un error al cargar los puntos, intentalo de nuevo más tarde',
      errorLoadPromotions: 'Ha ocurrido un error al cargar las promociones, intentalo de nuevo más tarde',
      errorLoadCoupons: 'Ha ocurrido un error al cargar los cupones, intentalo de nuevo más tarde',
      errorLoadCoupon: 'Ha ocurrido un error al cargar el cupón, intentalo de nuevo más tarde',
      errorCreatingCoupon: 'Ha ocurrido un error al crear el cupón, intentalo de nuevo más tarde',
    },
    termsAndConditions: {
      title: 'Términos y Condiciones',
      notAvailable: 'Los Términos y Condiciones no están disponibles en este momento.',
      back: 'Volver',
    },
    downloadApp: {
      title: '¡DESCÁRGATE LA APP DE MONTEPÍO!',
      hi: 'CONTINUAR EN LA APP...',
      available: 'Ya disponible en:',
      openApp: '',
      makeClickToOpen: 'Haz click en el siguiente boton para abrir la aplicación',
      clickToOpen: 'Abrir App',
      ifNotHaveOrNotOpen: 'Si aun no tienes la app, puedes descargarla desde:',
      errorOpenApp: 'Se ha producido un error al abrir la app. Abrela manualmente o si no la tienes descargala para poder continuar.',
    },
    paymentGateway: {
      title: 'Pasarela de pago',
      shippingAddressStep: {
        title: 'Tienda onlie',
        address: 'Dirección de envío',
        continue: 'Siguiente',
        form: [
          { label: 'Nombre', value: 'name', required: true },
          { label: 'Apellidos', value: 'lastName', required: true },
          { label: 'Correo electrónico', value: 'email', required: true },
          { label: 'Número celular', value: 'phone', required: true },
          { label: 'C.P.', value: 'cp', required: true },
          { label: 'País', value: 'country', required: true },
          { label: 'Estado', value: 'state', required: true },
          { label: 'Municipio', value: 'municipality', required: true },
          { label: 'Colonia', value: 'colony', required: true },
          { label: 'Calle', value: 'street', required: true },
          { label: 'Número', value: 'exteriorNumber', required: true },
        ],
      },
      paymentMethodStep: {
        title: 'Tienda onlie',
        paymentMethod: 'Forma de pago',
        subtitle: '¿Cómo quieres pagar?',
        payWithCard: 'Pagar con tarjeta',
      },
      confirmationStep: {
        title: 'Confirmación',
      },
    },
    paymentCheckout: {
      steps: {
        paymentOptions: 'Opciones de pago',
        contracts: 'Contratos',
        paymentMethod: 'Forma de pago',
        confirmation: 'Confirmación',
      },
      heading: {
        title: '¿Cómo quieres pagar?',
        subtitle: 'Elige tu método de pago preferido',
      },
      sections: {
        card: 'Pago con tarjeta',
        cash: 'Pago en efectivo',
        stores: 'Pago en tiendas',
      },
      methods: {
        bbva: { eyebrow: 'Pago a través del', title: 'portal de BBVA', description: 'Tarjeta de débito o crédito' },
        mercadoPago: { eyebrow: 'Procesado por', title: 'Mercado Pago', description: 'Tarjeta de débito o crédito' },
        paycash: { eyebrow: 'Efectivo en puntos de pago', title: 'PayCash' },
        puntored: { eyebrow: 'Efectivo en puntos de pago', title: 'PuntoRed' },
      },
      recommended: 'Recomendado',
      details: {
        secureTitle: 'Pago 100% seguro',
        secureBbva: 'Serás redirigido al portal oficial de BBVA.',
        secureMercadoPago: 'Tu pago se procesa de forma segura con Mercado Pago.',
        cardsTitle: 'Aceptamos tarjetas',
        cardsBbva: 'Débito y crédito Visa, Mastercard y American Express.',
        cardsMercadoPago: 'Tarjetas de débito y crédito.',
        privacyTitle: 'Protegemos tu información',
        privacyText: 'Tus datos están encriptados y seguros.',
      },
      paycashMaxAmount: 'Disponible para pagos de hasta {amount}',
      pay: 'Realizar pago',
      dataProtected: 'Tus datos están protegidos',
      dataProtectedSsl: 'Tus datos están protegidos con encriptación SSL.',
      secureCheckout: 'Pago 100% seguro',
      summary: {
        title: 'Resumen de tu pago',
        contract: 'Contrato {number}',
        section: 'Apartado {number}',
        extraAmount: 'Abono adicional',
        coverage: 'Cobertura',
        subtotal: 'Subtotal',
        total: 'Total a pagar',
        empty: 'Selecciona una opción de pago para ver el resumen.',
      },
      badges: {
        secureTitle: 'Pago 100% seguro',
        secureText: 'Tus datos están protegidos',
        supportTitle: 'Soporte al cliente',
        supportText: 'Estamos para ayudarte',
      },
      footer: '© Montepio Luz Saviñón I.A.P. Todos los derechos reservados.',
      activationError: {
        mercadoPago: 'No pudimos cargar Mercado Pago. Revisa tu conexión e inténtalo de nuevo.',
        generic: 'No pudimos cargar este método de pago. Inténtalo de nuevo.',
      },
      retry: 'Reintentar',
      loadingMethod: 'Cargando método de pago…',
      storeLogoAlt: 'Logo de {name}',
    },
    profile: {
      myProfile: 'Mi perfil',
      alias: 'Alias',
      phone: 'Celular',
      address: 'Dirección',
      email: 'Email',
      ine: 'INE',
      errorUploadingImage: 'Ha ocurrido un error al subir la imagen, el tamaño máximo son 10MB, revisa la imagen e intentalo de nuevo',
      noLibraryPermissions: 'No has dado permisos para acceder a las imagenes del dispositivo, revisa los permisos desde los ajustes del dispositivo e intentalo de nuevo',
      confirmChange: 'Confirma el cambio',
      introduceCode: 'Introduce el código de confirmación que te hemos enviado para poder continuar',
      invalidOtp: 'El código de confirmación es inválido',
      successSaved: 'Cambios guardados correctamente',
      editProfileInfo: 'Recuerda que solo se puede hacer una modificación al día de tus datos.',
      editProfile: 'Editar perfil',
      selectOption: 'Solo puedes realizar una modificación de uno de tus datos al día, por favor selecciona el que deseas modificar.',
      currentEmail: 'Email actual',
      interbankKey: 'Cuenta CLABE',
      newEmail: 'Nuevo email',
      currentPhone: 'Celular actual',
      newPhone: 'Nuevo celular',
      changePhone: 'Cambiar celular',
      changeEmail: 'Cambiar email',
      confirmEmailOTP: 'Te hemos enviado un código de confirmación a tu email',
      confirmSMSOTP: 'Te hemos enviado un código de confirmación por SMS a tu celular',
      confirmInfoBoth: 'Para poder realizar el cambio, te hemos enviado un código de confirmación a tu email y celular, estos codigos son independientes, por lo que pueden ser diferentes.',
      confirmInfoEmail: 'Para poder realizar el cambio, te hemos enviado un código de confirmación a tu email.',
      confirmInfoPhone: 'Para poder realizar el cambio, te hemos enviado un código de confirmación por SMS a tu celular.',
      emailOTP: 'Código de confirmación de email',
      phoneOTP: 'Código de confirmación de celular',
      lastEditTime: 'No puedes volver a editar tus datos hasta {date}',
      EMAIL_ALREADY_EXISTS: 'El correo ingresado ya se encuentra registrado',
      PHONE_ALREADY_EXISTS: 'El teléfono ingresado ya se encuentra registrado',
      ERROR_CREATING_EMAIL_OTP: 'Ocurrió un error al generar OTP',
      ERROR_CREATING_SMS_OTP: 'Ocurrió un error al generar OTP',
      ERROR_SENDING_EMAIL: 'Ocurrió un error al enviar OTP',
      ERROR_SENDING_SMS: 'Ocurrió un error al enviar OTP',
      ERROR_UPDATING_CLIENT: 'Ocurrió un error al actualizar el cliente',
      UPDATE_SAP_CLIENT_ERROR: 'Ocurrió un error al actualizar el cliente en SAP',
      INVALID_OTP_EMAIL: 'El código de confirmación del email es inválido',
      INVALID_OTP_PHONE: 'El código de confirmación del celular es inválido',
    },
    interbankKey: {
      title: 'CLABE interbancaria',
      thisIsYourInterbankKey: 'Muestralo para compartir tu cuenta, o haz click sobre el para copiar el número',
      noAccount: 'No tienes una cuenta CLABE',
      copySuccess: 'Copiado al portapapeles',
      copyError: 'Error al copiar al portapapeles',
      qr: 'QR',
      barcode: 'Código de barras',
    },
    executiveDriver: {
      title: 'Conductor ejecutivo',
      subtitle: 'Financia tu nuevo auto UBER',
      info1: '¿Ya eres conductor Uber? ¡Tenemos una oferta especial para ti en Montepío Luz Saviñón!',
      info2: 'Obtén un financiamiento exclusivo para adquirir tu propio auto con un plan de pagos fijos y sin enganche.',
      call: 'Llamar',
      weContactYou: 'Te contactamos',
      benefits: {
        title: 'Beneficios',
        gas: 'Bono gratuito de gasolina por apertura',
        noPayments: 'Sin enganche ni pagos residuales',
        coverageInsurance: 'Seguro de cobertura amplia',
        paymentCapacity: 'Adapta los plazos tu capacidad de pago',
        interestRate: 'Tasa de interés más baja que en una agencia',
        cars: 'Contamos con autos nuevos y seminuevos',
      },
      requirements: {
        title: 'Requisitos',
        age: 'Edad de 27 a 63 años',
        threeMonths: '3 meses de antigüedad vigente y continua en la plataforma',
        trips: '700 viajes realizados en esos 3 meses',
        rating: 'Calificación 4.7 estrellas',
        billing: 'Contar con las últimas 12 a 16 capturas de pantalla de facturación',
        location: 'Aplica en CDMX, Área Metropolitana y Estado de México',
      },
    },
    referrals: {
      title: 'Programa de referidos',
      intro: 'Comparte tu código para que otra persona se registre con él. Los beneficios del programa se reflejan cuando esa persona realiza su primer pago de empeño en línea elegible.',
      cardTitle: 'Programa de referidos',
      cardHeadline: 'Invita a tus amigos y gana puntos',
      cardDescription: 'Recibe puntos por tus referidos cuando realicen su primer pago de empeño en línea elegible.',
      viewProgram: 'Ver referidos',
      howItWorksTitle: '¿Cómo funciona?',
      howItWorksStep1: 'Comparte tu código personal de referidos.',
      howItWorksStep2: 'Invita a un amigo a registrarse utilizando tu código.',
      howItWorksStep3: 'Cuando tu amigo complete su primer pago de empeño en línea elegible, se reflejarán los puntos correspondientes.',
      considerationsTitle: 'Consideraciones',
      considerationsItem1: 'Los puntos dependen de las condiciones del programa.',
      considerationsItem2: 'Se reflejan cuando tu referido realiza su primer pago de empeño en línea elegible.',
      myCode: 'Mi código',
      copy: 'Copiar código',
      share: 'Compartir código',
      copySuccess: 'Código copiado',
      copyError: 'No se pudo copiar el código',
      shareError: 'No se pudo compartir el código',
      noCodeTitle: 'Tu código aún no está disponible',
      noCodeBody: 'Cuando el sistema asigne tu código, aparecerá aquí.',
      noInfoTitle: 'Aún no tienes información de referidos',
      noInfoBody: 'Tu código de referidos es asignado por nuestro sistema. Podrás consultarlo y compartirlo aquí cuando esté disponible.',
      backHome: 'Volver al inicio',
      myReferrals: 'Tus referidos',
      emptyList: 'Aún no tienes referidos.',
      loading: 'Cargando programa de referidos',
      codeLoading: 'Cargando tu código',
      listLoading: 'Cargando tus referidos',
      loadError: 'No pudimos cargar tu programa de referidos.',
      codeLoadError: 'No pudimos cargar tu código de referidos.',
      listLoadError: 'No pudimos cargar tus referidos.',
      retry: 'Reintentar',
      registeredAt: 'Fecha de registro',
      status: 'Estatus',
      progressLabel: 'Progreso del referido',
      stagePreregistro: 'Preregistro',
      stageContrato: 'Contrato',
      stagePago: 'Pago en línea',
      stageBonificacion: 'Bonificación',
      pts: 'Pts',
      pointsMissing: 'Sin dato',
      valueMissing: '—',
    },
    digitalLoan: {
      intro: {
        heroAlt: 'Luchito',
        title: '¡Aprovecha tu cercanía con nosotros!',
        subtitle: 'Tienes acceso a un préstamo exclusivo para clientes de la zona.',
        requirementsTitle: 'Requisitos para solicitarlo:',
        requirements: [
          'Residir o trabajar cerca de una de nuestras sucursales.',
          'Contar con un bien como garantía el cual siempre estará contigo.',
          'Permitirnos conocer tu historial crediticio.',
          'Tener ingresos que respalden tu préstamo.',
          'Estabilidad laboral o arraigo en el domicilio.',
        ],
        apply: 'SOLICITAR PRÉSTAMO',
        later: 'En otro momento',
      },
      permissions: {
        title: 'Permisos',
        intro1: 'Para continuar con tu solicitud, es necesario que leas y aceptes los siguientes documentos.',
        intro2: 'Al aceptar, validaremos tu información para poder ofrecerte una oferta de préstamo acorde a tu perfil.',
        labels: {
          privacy: 'Aviso de Privacidad',
          terms: 'Términos y Condiciones',
          bureau: 'Consulta a Buró de Crédito',
          imss: 'Consulta a IMSS/ISSSTE',
        },
        accept: 'ACEPTAR',
        back: 'VOLVER',
        viewer: {
          loadError: 'No se pudo mostrar el documento.',
          zoomIn: 'Acercar',
          zoomOut: 'Alejar',
        },
      },
      biometric: {
        title: 'Verificación biométrica',
        description1: 'Para continuar con tu solicitud, necesitamos verificar tu identidad mediante biometría.',
        description2: 'Asegúrate de tener activada la biometría en tu teléfono.',
        prompt: 'Realiza la validación biométrica para continuar.',
        errorTitle: 'No pudimos validar tu biometría',
        errorMessage: 'Intenta nuevamente o revisa que Face ID / huella esté configurado en tu dispositivo.',
        retry: 'INTENTAR DE NUEVO',
        back: 'VOLVER',
      },
      verificationLoader: {
        title: 'Por favor, espera...',
        verifying: 'Verificando...',
      },
      rejection: {
        understood: 'ENTENDIDO',
        blacklist: {
          title: 'Solicitud no disponible',
          body: 'Hemos encontrado una restricción en los registros de verificación, por lo que no es posible procesar tu solicitud de préstamo en este momento.',
          websiteIntro: 'Si necesitas más información consulta nuestra página de internet en',
          websiteLabel: 'www.montepio.org.mx',
        },
        location: {
          title: 'Solicitud de préstamo no disponible',
          body: 'Uno de los requisitos para solicitar este préstamo por cercanía, es que residas o trabajes cerca de una de nuestras sucursales.',
          bodySecondary: 'Sin embargo si lo deseas contamos con otras alternativas que ponemos a tu disposición.',
          websiteIntro: 'Acércate a tu sucursal más cercana o visita nuestra página en',
          websiteLabel: 'www.montepio.org.mx',
        },
        applicability: {
          title: 'Solicitud de préstamo no disponible',
          body: 'Uno de los requisitos para solicitar este préstamo, es tener un bien para dejar en garantía con un valor comercial igual o superior al 30% del importe solicitado.',
          bodySecondary: 'Si lo deseas, un asesor puede contactarte para revisar otras alternativas que se ajusten al bien que puedes dejar en garantía.',
          websiteIntro: 'Te invitamos a explorar otras opciones, acércate a tu sucursal más cercana o visita nuestra página en',
          websiteLabel: 'www.montepio.org.mx',
        },
      },
      location: {
        title: 'Ubicación',
        proximityQuestion: '¿Vives o trabajas cerca de una sucursal?*',
        proximityHint: 'Recuerda que el bien que se usará como garantía debe estar ubicado físicamente en este domicilio.',
        options: {
          live: 'Vivo cerca',
          work: 'Trabajo cerca',
          business: 'Tengo un negocio cerca',
          unsure: 'No estoy seguro',
        },
        companyNameLabel: 'Nombre de la empresa',
        businessNameLabel: 'Nombre del negocio',
        postalQuestion: '¿Cuál es el código postal?',
        postalLabel: 'Código postal',
        postalCodeError: 'El código postal debe tener 5 dígitos',
        locationHelpTitle: 'Ayúdanos a validar tu dirección',
        locationHelpText: 'Necesitamos acceder a la ubicación de tu dispositivo para validar que estás dentro del área permitida para obtener el préstamo por cercanía.',
        locationAuth: 'Autorizo compartir mi ubicación*',
        validate: 'VALIDAR',
        back: 'VOLVER',
        accept: 'ACEPTAR',
        locationUnavailable: 'No pudimos acceder a tu ubicación. Activa la ubicación de tu dispositivo desde configuración e intenta nuevamente.',
        postalCodeNotFound: 'El código postal ingresado no existe',
        locationErrors: {
          permission_denied: 'No fue posible obtener tu ubicación. Autoriza el acceso a tu ubicación para continuar.',
          unavailable: 'No fue posible obtener tu ubicación. Intenta de nuevo.',
          unsupported: 'La geolocalización no está disponible en este dispositivo.',
        },
      },
      questionnaire: {
        common: {
          next: 'SIGUIENTE',
          back: 'VOLVER',
        },
        submitError: 'No pudimos enviar tu cuestionario. Intenta nuevamente más tarde.',
        loan: {
          title: 'Cuestionario de Aplicabilidad',
          subtitle: 'Tú decides porque tú tienes el control.',
          requiredNote: '*Campos obligatorios',
          amountQuestion: '¿Cuánto te gustaría solicitar?*',
          amountMin: 'Mínimo $5,000',
          amountMax: 'Máximo $25,000',
          frequencyQuestion: '¿Cada cuándo quieres realizar tus pagos?*',
          frequencyPlaceholder: 'Selecciona una opción',
          frequencyOptions: {
            biweekly: 'Catorcenal',
            monthly: 'Mensual',
          },
          termQuestion: 'Plazo*',
          termUnits: {
            biweekly: 'catorcenas',
            monthly: 'meses',
          },
          termValue: '{count} {unit}',
          termMin: 'Mínimo {count}',
          termMax: 'Máximo {count}',
        },
        address: {
          title: 'Cuestionario de Aplicabilidad',
          requiredNote: '*Campos obligatorios',
          addressQuestion: '¿Cuál es la dirección donde vives?',
          streetLabel: 'Calle',
          exteriorLabel: 'Número exterior',
          exteriorPlaceholder: 'N° de la calle',
          interiorLabel: 'Número interior',
          interiorPlaceholder: 'N° interior si hubiera',
          postalLabel: 'Código postal',
          stateLabel: 'Estado',
          municipalityLabel: 'Alcaldía / Municipio',
          colonyLabel: 'Colonia',
          otherOption: 'Otro',
          addressLookupError: 'No encontramos colonias para este código postal. Puedes capturarla manualmente.',
          yearsQuestion: '¿Cuántos años llevas viviendo en esa dirección?*',
          yearsPlaceholder: 'Selecciona una opción',
          yearsOptions: {
            lessThan1: 'Menos de 1 año',
            oneToThree: '1 a 3 años',
            fourToSix: '4 a 6 años',
            sevenToNine: '7 a 9 años',
            nineToTen: '9 a 10 años',
            tenOrMore: '10 o mas',
          },
          proof: {
            title: 'Agregar comprobante de domicilio*',
            addFile: 'Agregar archivo',
            or: 'o',
            openCamera: 'Abrir cámara y tomar foto',
            invalidFileType: 'Selecciona un archivo de imagen o PDF válido.',
          },
        },
        identity: {
          title: 'Cuestionario de Aplicabilidad',
          requiredNote: '*Campos obligatorios',
          rfcQuestion: 'RFC con Homoclave*',
          rfcLabel: 'RFC con Homoclave',
          rfcError: 'Ingresa un RFC con homoclave de 13 caracteres.',
          curpQuestion: 'CURP*',
          curpLabel: 'CURP',
          curpError: 'Ingresa tu CURP de 18 caracteres',
          incomeQuestion: 'Ingresos mensuales*',
          incomeMin: 'Mínimo $3,000',
          incomeMax: 'Más de $150,000',
        },
      },
      phase2: {
        common: {
          back: 'VOLVER',
          loading: 'Cargando...',
          next: 'SIGUIENTE',
          understood: 'ENTENDIDO',
        },
        guaranteeAvailability: {
          title: 'Prenda en garantía',
          subtitle: 'Para continuar con tu solicitud necesitamos un bien que dejes en garantía.',
          question: '¿Cuentas con un bien para dejar en garantía?',
          yes: 'Sí',
          no: 'No',
          back: 'VOLVER',
          understood: 'ENTENDIDO',
          accept: 'ACEPTAR',
          cancel: 'CANCELAR',
          requirementTitle: '¿Tienes un bien para dejar en garantía?',
          requirementItems: [
            'Debes contar con una prenda que cubra el 30% del monto del préstamo solicitado.',
            'Asegúrate de estar físicamente en el domicilio donde se encuentra la prenda, ya que debes tomarle algunas fotos.',
            'El pago del préstamo será realizado solo por transferencia bancaria, por lo que debes contar con una cuenta de depósito a tu nombre.',
          ],
          noProductTitle: 'Solicitud de préstamo no disponible',
          noProductBody: 'Uno de los requisitos para solicitar este préstamo es contar con un bien para dejar en garantía.',
          noProductWebsiteIntro: 'Acércate a tu sucursal más cercana o visita nuestra página en',
          noProductWebsiteLabel: 'www.montepio.org.mx',
        },
        catalog: {
          title: 'Selecciona la prenda que dejarás en garantía',
          subtitle: 'Esto nos ayuda a validar tu solicitud.',
          note: '(La prenda que registres debe tener un valor comercial de al menos el 30% del monto del préstamo solicitado)',
          familyLabel: 'Familia',
          subFamilyLabel: 'Subfamilia',
          articleLabel: 'Artículos',
          brandLabel: 'Marcas',
        },
        model: {
          title: 'Selecciona la prenda que dejarás en garantía',
          intro1: 'Necesitamos unos últimos datos sobre el bien que vas a presentar como garantía.',
          intro2: 'Esta información nos permitirá estimar su valor comercial y completar tu solicitud de préstamo.',
          modelLabel: 'Modelo',
          modelPlaceholder: 'Introduce modelo',
          manualModelLabel: 'Modelo',
          familyLabel: 'Familia',
          familyPlaceholder: 'Introduce familia',
          subFamilyLabel: 'Subfamilia',
          subFamilyPlaceholder: 'Introduce subfamilia',
          articleLabel: 'Artículo',
          articlePlaceholder: 'Introduce artículo',
          brandLabel: 'Marca',
          brandPlaceholder: 'Introduce marca',
          otherOption: 'OTRO',
          descriptionLabel: 'Descripción:',
          conditionLabel: 'Estado',
          conditionPlaceholder: 'Selecciona una opción',
          estimatedValueLabel: 'Valor estimado',
          estimatedValuePlaceholder: 'Introduce valor estimado',
          estimatedValueHint: 'El valor se redondeará a la centena más cercana',
          next: 'SIGUIENTE',
          back: 'VOLVER',
          conditions: {
            excellent: 'Excelente',
            good: 'Bueno',
            fair: 'Regular',
          },
        },
        photos: {
          title: 'Validación de la prenda',
          intro1: 'Necesitamos algunas fotos de una prenda de tu propiedad que utilizarás como garantía.',
          intro2: 'Esta información nos permitirá estimar su valor comercial y completar tu solicitud de préstamo.',
          requiredTitle: 'Fotos requeridas:',
          requiredFront: '1 foto frontal de la prenda.',
          requiredAngles: '5 fotos de distintos ángulos de la prenda (trasera, laterales, superior e inferior).',
          requiredLabel: '1 foto de la etiqueta o identificador (opcional)',
          requiredLabelHint: 'Si no tienes una, puedes omitirla.',
          optionalDocument: '1 foto de factura, recibo o comprobante de propiedad (opcional)',
          optionalDocumentHint: 'Si no tienes uno, puedes omitirlo.',
          hasInvoice: '¿Dispones de factura, recibo o comprobante de propiedad?',
          isOwner: 'Confirmo que soy el propietario de la prenda',
          cameraAuthorized: 'Autorizo el uso de la cámara',
          takePhotos: 'TOMAR FOTOS',
          continue: 'CONTINUAR',
          back: 'VOLVER',
          understood: 'ENTENDIDO',
          recommendationsTitle: 'Recomendaciones para tomar las fotos:',
          recommendations: [
            'Coloca la prenda en un lugar bien iluminado.',
            'Asegúrate de que esté limpio y visible.',
            'Evita reflejos, sombras fuertes o imágenes borrosas.',
            'Revisa que el comprobante esté legible.',
          ],
        },
        photoCapture: {
          title: 'Captura de fotos',
          frontLabel: 'Foto frontal',
          anglesLabel: 'Fotos de distintos ángulos',
          labelLabel: 'Foto de la etiqueta o identificador',
          labelHint: 'Si no tienes una, puedes omitirla.',
          documentLabel: 'Factura, recibo o comprobante de propiedad',
          addFront: 'Agregar foto frontal',
          addAngle: 'Ángulo',
          angleSlotLabels: [
            'Foto trasera',
            'Foto lateral derecha',
            'Foto lateral izquierda',
            'Foto superior',
            'Foto inferior',
          ],
          addLabel: 'Agregar etiqueta',
          addDocument: 'Agregar factura, recibo o comprobante',
          addPhoto: 'Agregar foto',
          changePhoto: 'Cambiar foto',
          deleteAll: 'Borrar todas',
          deleteConfirmTitle: '¿Deseas borrar todas las imágenes?',
          deleteConfirmBody: 'Se quitarán las fotos de esta captura. Podrás tomarlas de nuevo.',
          cancelDelete: 'Cancelar',
          confirmDelete: 'Borrar imágenes',
          review: 'REVISAR FOTOS',
          back: 'VOLVER',
        },
        photoReview: {
          title: 'Fotos de tu prenda',
          subtitle: 'A continuación, vamos a revisar las imágenes que acabas de realizar. Este proceso nos permite confirmar que el artículo coincide con la información registrada.',
          frontLabel: 'Foto frontal',
          anglesLabel: 'Fotos de distintos ángulos',
          labelLabel: 'Foto de la etiqueta o identificador',
          documentLabel: 'Factura, recibo o comprobante de propiedad',
          angleSlotLabels: [
            'Foto trasera',
            'Foto lateral derecha',
            'Foto lateral izquierda',
            'Foto superior',
            'Foto inferior',
          ],
          emptySlot: 'Sin foto',
          changePhoto: 'Cambiar foto',
          deleteAll: 'Borrar todas',
          deleteConfirmTitle: '¿Deseas borrar todas las imágenes?',
          deleteConfirmBody: 'Se quitarán las fotos de esta captura. Podrás tomarlas de nuevo.',
          cancelDelete: 'Cancelar',
          confirmDelete: 'Borrar imágenes',
          validate: 'VALIDAR',
          back: 'VOLVER',
          validationLoader: {
            title: 'Estamos validando tus imágenes.',
            verifying: 'Este proceso puede tomar un par de minutos, por favor no cierres esta pantalla.',
          },
        },
        validationFailed: {
          title: 'Validación de prenda',
          subtitle: 'No hemos podido validar la prenda',
          body1: 'Parece que las imágenes enviadas no coinciden con la información de la prenda que has proporcionado.',
          body2: 'Por favor, toma nuevamente las fotos para que podamos validar tu garantía correctamente.',
          retakePhotos: 'TOMAR FOTOS',
          changePledgeHint: 'Si lo prefieres, también puedes cambiar la prenda que deseas dejar en garantía.',
          changePledge: 'CAMBIAR PRENDA',
          back: 'VOLVER',
        },
        insufficientValue: {
          pageTitle: 'Valor insuficiente',
          pageSubtitle: 'Tu prenda no cubre el valor requerido.',
          pageBody: 'El valor comercial de la prenda es menor al 30% del importe del préstamo que estás solicitando.',
          optionsTitle: 'Para continuar, puedes elegir entre:',
          options: [
            'Seleccionar otra prenda como garantía.',
            'Aceptar un nuevo importe de préstamo, ajustado al valor de tu garantía.',
          ],
          continueWithLowerAmount: 'CONTINUAR CON MONTO MENOR',
          selectOtherPledge: 'SELECCIONAR OTRA PRENDA',
          back: 'VOLVER',
        },
        missingOnboarding: {
          title: '¡Ya casi terminamos!',
          body1: 'Las fotos de tu prenda están correctas y estás muy cerca de finalizar tu trámite.',
          body2: 'Sin embargo, hemos detectado que aún no has completado el proceso de onboarding obligatorio dentro de la aplicación.',
          completeIdentification: 'COMPLETAR IDENTIFICACIÓN',
          back: 'VOLVER',
        },
        notPreapproved: {
          title: '¡Gracias por tu solicitud! Tu préstamo no ha sido Preaprobado.',
          subtitle: 'Hemos revisado tu información y, en este momento, no cumples con los requisitos necesarios para generar una oferta preliminar.',
          loanSection: 'Préstamo',
          amountLabel: 'Monto de préstamo: ',
          termLabel: 'Plazo: ',
          termUnit: 'meses',
          frequencyLabel: 'Frecuencia de pago: ',
          paymentDayLabel: 'Días de pago: ',
          modifyTerm: 'MODIFICAR PLAZO',
          selectOtherPledge: 'SELECCIONAR OTRA PRENDA',
          back: 'VOLVER',
        },
        preOffer: {
          title: '¡Buenas noticias!\n¡Tu préstamo está preaprobado!',
          subtitle: 'Hemos generado una oferta preliminar basada en tu información. El monto final está sujeto a la revisión de la prenda en garantía.',
          loanSection: 'Préstamo',
          amountLabel: 'Monto de préstamo: ',
          cappedAmount: 'Tu equipo avalúa en {appraisal}, pero el monto máximo de este producto es {maxAmount}.',
          termLabel: 'Plazo: ',
          termUnit: 'meses',
          frequencyLabel: 'Frecuencia de pago: ',
          paymentDayLabel: 'Días de pago: ',
          guaranteeSection: 'Prenda en garantía',
          visitSection: 'Visita domiciliaria',
          visitHint: 'Por favor, selecciona en el calendario el día y horario en el que prefieres recibir la visita del Gestor para la validación domiciliaria.',
          selectDay: 'Seleccionar día',
          selectTime: 'Seleccionar horario',
          finish: 'CONTINUAR',
        },
      },
      phase3: {
        visitStatus: {
          title: 'Tu préstamo está en proceso',
          subtitle: 'Esta oferta está sujeta a la aprobación de la solicitud una vez se haya analizado.',
          loanSection: 'Préstamo',
          amountLabel: 'Monto de préstamo: ',
          cappedAmount: 'Tu equipo avalúa en {appraisal}, pero el monto máximo de este producto es {maxAmount}.',
          termLabel: 'Plazo: ',
          termUnit: 'meses',
          frequencyLabel: 'Frecuencia de pago: ',
          paymentDayLabel: 'Días de pago: ',
          visitSection: 'Visita domiciliaria',
          visitDayLabel: 'Día: ',
          visitTimeLabel: 'Hora: ',
          emptyValue: '- -',
          guaranteeSection: 'Prenda en garantía',
          modifySection: 'Modificar o cancelar la visita',
          modifyHint: 'Puedes modificar tu visita hasta 24 hrs antes. Pasado ese tiempo, ya no será posible cancelarla.',
          withinCutoffHint: 'Ya no puedes modificar ni cancelar la visita. Faltan menos de 24 horas para la cita.',
          modify: 'MODIFICAR',
          cancel: 'CANCELAR',
          selectDay: 'Seleccionar día',
          selectTime: 'Seleccionar horario',
          confirmReschedule: 'CONFIRMAR',
          maxReschedulesReached: 'Ya no puedes modificar la visita. Alcanzaste el máximo de reagendos.',
          scheduleAgainTitle: 'Programa visita domiciliaria con el gestor',
          rescheduleSuccessTitle: 'La visita domiciliaria del gestor se ha reprogramado correctamente.',
          rescheduleSuccessBody1: 'Asegúrate de estar en la dirección que proporcionaste en la fecha y hora acordadas.',
          rescheduleSuccessBody2: 'Nuestro gestor acudirá para realizar la verificación de la prenda.',
          cancelConfirmTitle: '¿Seguro que quieres cancelar la visita domiciliaria del gestor?',
          cancelConfirmBody: 'Si cancelas la visita, el proceso de tu préstamo se detendrá hasta que vuelvas a agendar una nueva cita.',
          cancelConfirmHint: 'Recuerda que, si la fecha y hora no te vienen bien, puedes reprogramar la visita.',
          cancelConfirmCta: 'CANCELAR VISITA',
          cancelSuccessTitle: 'La visita domiciliaria del gestor ha sido cancelada correctamente.',
          cancelSuccessBody: 'Si deseas continuar con tu solicitud, podrás agendar una nueva visita cuando lo necesites.',
          understood: 'ENTENDIDO',
          back: 'VOLVER',
        },
      },
      phase4: {
        offer: {
          title: 'Solicitud de préstamo aprobada',
          subtitle: 'Esta es la oferta disponible para ti según tu información y validaciones realizadas.',
          backofficeReview: 'Tu solicitud sigue en revisión. Mostramos la información que ya está disponible.',
          windowWarning: 'En este momento no se puede generar el contrato. Puedes aceptar la oferta. Podrás continuar a partir de',
          loading: 'Estamos consultando tu oferta.',
          loanSection: 'Préstamo',
          amountLabel: 'Monto de préstamo',
          termLabel: 'Plazo',
          termUnit: 'meses',
          termUnitBiweekly: 'catorcenas',
          commissionLabel: 'Comisión de apertura: ',
          rateLabel: 'Tasa de interés: ',
          amountWithCommissionLabel: 'Monto con comisión: ',
          paymentTypeLabel: 'Frecuencia de pago',
          totalLabel: 'Total a pagar: ',
          expiresLabel: 'Vigencia: ',
          scheduleTitle: 'Calendario de pagos',
          viewSchedule: 'Ver calendario de pagos',
          emptySchedule: 'El calendario de pagos aún no está disponible.',
          documentsTitle: 'Documentos PDF',
          documents: {
            financialRun: 'Simulación Corrida Financiera',
            promissoryNote: 'Pagaré',
            contractClauses: 'Cláusulas del Contrato',
            borrowerLetter: 'Carta para acreditados',
          },
          emptyValue: '- -',
          accept: 'ACEPTAR OFERTA',
          reject: 'RECHAZAR OFERTA',
          retry: 'REINTENTAR',
          expiredNotice: 'La oferta anterior venció. Revisa la nueva oferta antes de aceptarla.',
          mismatchNotice: 'La oferta se actualizó. Revísala de nuevo antes de aceptarla.',
        },
        reject: {
          title: 'Rechazar oferta',
          body: 'Nos gustaría conocer el motivo por el que no aceptaste la oferta.',
          detailPlaceholder: 'Cuéntanos brevemente',
          confirm: 'ACEPTAR',
          back: 'VOLVER',
          unavailable: 'No pudimos registrar el rechazo porque el servicio todavía no está disponible.',
          failed: 'No pudimos registrar el rechazo. Inténtalo de nuevo.',
          notAvailable: 'No hay una oferta disponible para rechazar.',
          doneTitle: 'Oferta rechazada',
          doneBody: 'Has rechazado la oferta disponible.',
          doneHint: 'Si cambias de opinión o deseas solicitar un préstamo más adelante, estaremos aquí para ayudarte.',
          doneAction: 'ACEPTAR',
          reasons: [
            { id: 'NO_LONGER_NEEDED', label: 'Ya no requiero el préstamo' },
            { id: 'AMOUNT_TOO_LOW', label: 'El monto ofrecido es muy bajo' },
            { id: 'NO_COLLATERAL', label: 'Ya no cuento con el producto en garantía' },
            { id: 'ADDRESS_OR_JOB_CHANGED', label: 'Cambié de domicilio o trabajo' },
            { id: 'BETTER_OFFER', label: 'Obtuve una mejor oferta con otra Institución' },
            { id: 'OTHER', label: 'Otro' },
          ],
        },
        clabe: {
          title: 'Cuenta para depósito',
          body: 'El desembolso del préstamo se realizará exclusivamente mediante transferencia bancaria.',
          holder: 'El titular de la cuenta de depósito y de la CLABE debe ser la misma persona que solicita el préstamo en Montepío.',
          label: 'N° cuenta CLABE',
          submit: 'CONTINUAR',
          verify: 'Verificar cuenta',
          back: 'VOLVER',
          validated: 'La cuenta fue verificada.',
          invalid: 'Revisa la CLABE e inténtalo de nuevo.',
          invalidAccount: 'La CLABE no corresponde a una cuenta.',
          nameMismatch: 'La cuenta existe, pero el nombre del titular no coincide con el de tu solicitud.',
          returned: 'El depósito fue devuelto por datos inválidos. Revisa la CLABE.',
          unavailable: 'No pudimos validar la cuenta en este momento. Inténtalo más tarde.',
        },
        biometric: {
          title: 'Validación de identidad',
          body: 'A continuación vamos a tomar una foto "selfie" de tu rostro para confirmar tu identidad y finalizar tu solicitud.',
          recommendationsTitle: 'Recomendaciones para tomar la foto:',
          recommendations: [
            'Mira de frente a la cámara.',
            'Evita reflejos, sombras fuertes y asegúrate de estar bien iluminado.',
            'No uses accesorios que cubran tu rostro.',
            'Asegúrate de estar enfocado y centrado.',
          ],
          privacyTitle: 'Tu información esta protegida.',
          privacyBody: 'Las fotografía se utilizará únicamente para validar tu identidad y completar tu solicitud.',
          cameraAuthorization: 'Autorizo el uso de la cámara',
          takePhotos: 'TOMAR FOTOS',
          back: 'VOLVER',
          rejected: 'No pudimos confirmar tu identidad. Intenta con otra foto.',
          enrollmentMissing: 'No encontramos un registro facial de tu alta. No basta con repetir la foto.',
          temporaryError: 'La validación no está disponible en este momento. Inténtalo más tarde.',
        },
        contract: {
          title: 'Generar contrato',
          body: 'Al continuar generamos tu contrato. El depósito se procesará después.',
          generate: 'GENERAR CONTRATO',
          failed: 'No pudimos generar el contrato. Puedes intentarlo de nuevo.',
          notGenerated: 'El contrato todavía no está generado. Puedes intentarlo de nuevo.',
        },
        window: {
          title: 'Fuera del horario operativo',
          body: 'Tu solicitud sigue adelante. El contrato se podrá generar cuando abra el horario operativo.',
          pendingLabel: 'Podrás continuar a partir de: ',
          refresh: 'REVISAR ESTADO',
        },
        ready: {
          title: 'Tu contrato está listo',
          body: 'El contrato de tu préstamo ya fue generado.',
          depositLater: 'El depósito se procesará después. Aún no está depositado.',
          documentsTitle: 'Documentos',
          documentInvalid: 'No pudimos abrir ese documento.',
          home: 'IR AL INICIO',
          documents: {
            mutualContract: 'Contrato de mutuo',
            borrowerLetter: 'Carta para acreditados',
            paymentSchedule: 'Calendario de pagos',
            promissoryNote: 'Pagaré',
          },
        },
      },
    },
    contract: {
      myDeadlines: 'Mis plazos',
      contract: 'Contrato',
      section: 'Apartado',
      returned: 'Abonado',
      pending: 'Restante',
      total: 'Monto de Préstamo',
      coverage: 'Cobertura',
      pendingCapital: 'Capital restante',
      nextExpiration: 'Fecha de vencimiento:',
      amortize: 'Aplicar pago',
      paymentsHistory: 'Historial de pagos',
      payments: 'Historial de pagos',
      pendingPayments: 'Pagos pendientes',
      CANCELED: 'Cancelado',
      PAID: 'Pagado',
      PENDING: 'Pendiente',
      FAILED: 'Fallido',
      PENDING_SAP: 'Pendiente SAP',
      status: 'Estatus',
      graceExpiration: 'Fecha de gracia',
      extemporaneousExpiration: 'Fecha de vencimiento extemporáneo:',
      commercializationStartDate: 'Fecha de inicio comercialización:',
      errorDownloadNote: 'Ha ocurrido un error al descargar la nota de pago, intentalo de nuevo más tarde.',
      downloadReceipt: 'Descargar comprobante',
      contract03NotExtended: 'Recuerda que este modelo de contratos no extiende calendario, por lo que te sugerimos realizar la liquidación o re empeño de tu prenda en sucursal.',
      sectionLessThan20: 'Tu saldo pendiente es de {amount}, para liquidarlo favor de pasar a la sucursal de origen de tu apartado.',
      noPaymentOptions: 'No hay opciones de pago disponibles, por favor contacta con nosotros si necesitas realizar un pago.',
    },
    contractPay: {
      amortize: 'Opciones de pago',
      paymentConcept: 'Concepto',
      operationType: 'Tipo de operación',
      limitDate: 'Fecha límite de pago',
      newPaymentDate: 'Nueva fecha de pago:',
      minimumPayment: 'Pago Mínimo*',
      suggestedPayment: 'Pago Mensual Sugerido**',
      extensionPayment: 'Extensión de plazo',
      abono20OrMore: 'Abono de 20 o más',
      minAmountRule: 'El monto mínimo de pago es de {amount}',
      selectPaymentOption: 'Selecciona una opción de pago',
      payCoverage: 'Abono de cobertura',
      contractAmount: 'Monto contrato',
      sectionAmount: 'Monto apartado',
      coverageAmount: 'Monto cobertura',
      showPaymentOptions: 'Mostrar opciones de pago',
      totalAmountToPay: 'Total a pagar: {amount}',
      disabledCoverageOnThisOption: 'No se puede abonar cobertura con esa opción de pago',
      maxAmountCoverage: 'El monto no puede dejar el saldo de la cobertura con menos del 10% de su valor total, si quieres liquidarla debes ir a una sucursal.',
      payCoverageInShop: 'Favor de acudir a sucursal para liquidación de su cobertura, el saldo pendiente es de {amount}',
      cannotPayCoverageWithPaymentOption: 'No se puede pagar solo la cobertura, favor de seleccionar una opción de pago',
      paymenOptionsTitle: {
        1205: 'Liquidación',
        1219: 'Liquidación de contrato',
        1225: 'Refrendo {months} {monthsLiteral}',
        1230: 'Refrendo {months} {monthsLiteral} + Pago a capital',
        1235: 'Refrendo {months} {monthsLiteral}',
        1240: 'Refrendo {months} {monthsLiteral} + Pago a capital',
        1503: 'Extensión {months} {monthsLiteral}',
        1514: 'Extensión {months} {monthsLiteral}',
        1515: 'Refrendo (extensión de contrato)',
      },
      paymenOptionsDescription: {
        1205: 'Paga el total del refrendo y capital restante para recuperar la prenda en periodo vigente',
        1219: 'Paga el total del refrendo y capital restante para recuperar la prenda en periodo adicional',
        1225: 'Extiende el contrato por {months} {monthsLiteral} meses (por lo general se muestra en periodo vigente cuando se paga el total de intereses pendientes a la fecha de la consulta)',
        1230: 'Extiende el contrato por {months} {monthsLiteral} y reduce deuda',
        1235: 'Extiende el contrato por {months} {monthsLiteral} (por lo general se muestra en periodo vencido cuando se paga el total de intereses pendientes a la fecha de la consulta)',
        1240: 'Extiende el contrato por {months} {monthsLiteral} y reduce deuda',
        1503: 'Extiende el contrato por {months} {monthsLiteral}',
        1514: 'Extiende el contrato por {months} {monthsLiteral}',
        1515: 'Pago de uno o mas periodos adeudados sin cubrir la totalidad de los periodos pendientes',
      },
      amount: 'Monto del pago',
      pay: 'Realizar pago',
      paymentMethod: '¿Cómo quieres pagar?',
      maxAmountPaycash: 'Máximo {amount}',
      payWithCard: 'Pagar con tarjeta',
      paymetResume: 'Resumen del pago',
      warningTitle: 'Atención',
      paymetAuthorization: 'No. de Autorización',
      returnToApp: 'Ya puedes cerrar esta ventana y volver a la app',
      contracts: 'Contratos',
      contract: 'Contrato',
      empaque: 'Empaque',
      section: 'Apartado',
      date: 'Fecha',
      card: 'Tarjeta',
      mercadopago: 'Mercado Pago',
      cardBancomerDescription: 'Pago a través del portal de BBVA',
      cardBancomer: 'Portal Bancario BBVA',
      mercadopagoDescription: 'Procesado por Mercado Pago',
      referencePayment: 'Efectivo en puntos de pago',
      paymentMethod2: 'Forma de pago',
      sectionExtensionNotice: 'La opción de pago que seleccionaste, solo va a realizar la <b>EXTENSIÓN</b> al calendario, este monto no va a realizar ningún abono a tu capital.',
      pendingAmount: 'Saldo pendiente',
      liquidationAlertTitle: 'IMPORTANTE',
      liquidationAlertMessage: 'Recuerda que al liquidar tu contrato de empeño, por nuestros medios digitales (app/ portal), deberás esperar un lapso de 24 horas después de efectuado tu pago, para acudir a sucursal a recoger tu prenda.',
      accept: 'Aceptar',
      downloadNote: 'Descargar nota de pago',
      status: 'Estatus',
      totalAmount: 'Total a pagar',
      totalAmountPaid: 'Total pagado',
      noPayments: 'No tienes pagos',
      onlyOnePayment: 'Un pago al día',
      noPayment: 'No pagar',
      pendingCapital: 'Capital restante',
      office: 'Sucursal',
      numContracts: 'Número de contratos',
      multiplePayment: 'Pago múltiple',
      multipleResume: 'Has seleccionado {contracts} contratos con un valor total de {amount}',
      paymentNotFound: 'No se ha encontrado el pago',
      failureLoadingReference: 'Error al cargar referencia',
      failureLoadingReferenceDescription: 'Ha ocurrido un error al cargar la referencia de pago, revisa el estado del pago en los detalles del contrato',
      paycash: 'PayCash',
      puntored: 'PuntoRed',
      statusValues: {
        // COMPLETED, PENDING, CANCELED, PAYMENT_SAP_PENDING, FAILED, PENDING_SAP_CON
        PENDING: 'Pendiente',
        COMPLETED: 'Completado',
        CANCELED: 'Cancelado',
        PAYMENT_SAP_PENDING: 'Pendiente SAP',
        PENDING_SAP_CON: 'Pendiente banco',
        PENDING_3DS_CHALLENGE: 'Pendiente Challenge 3DS',
        FAILED: 'Fallido',
      },
      bancomer: {
        confirmTitle: 'Confirmación de pago',
        confirmDescription: '¿Estás seguro de que deseas realizar el pago? Se te redirigirá a la pasarela de pago de BBVA para completar la transacción.',
        confirmDescriptionExternalRedirect: '*Se abrirá el navegador para completar la transacción.',
        successTitle: 'Pago exitoso',
        failureTitle: 'Error al realizar el pago',
        failureReferenceTitle: 'Error al crear referencia',
        failureReferenceDescription: 'Ha ocurrido un error al crear la referencia de pago, por favor intenta de nuevo',
      },
      paymentSummaryBarcode: {
        scanLabel: 'Confirmación de pago',
      },
      reference: {
        successContractTitle: 'SE HA GENERADO UNA ORDEN DE PAGO PARA EL CONTRATO Nº {id}',
        successSectionTitle: 'SE HA GENERADO UNA ORDEN DE PAGO PARA EL APARTADO Nº {id}',
        successMultipleTitle: 'SE HA GENERADO UNA ORDEN DE PAGO MÚLTIPLE',
        successDescription: 'En breve recibirás un email de confirmación con los siguientes datos para realizar el pago:',
        paycashSearchStoreButton: 'Buscar sucursal para pagar',
        reference: 'Referencia',
        contractNumber: 'Número de contrato',
        sectionNumber: 'Número de apartado',
        issueDate: 'Fecha de emisión',
        amount: 'Monto del pago',
        failureTitle: 'Error al crear referencia',
        failureDescription: 'Ha ocurrido un error al crear la referencia de pago, por favor intenta de nuevo',
        generatePaymentOrder: 'Generar orden de pago',
        amountError: 'El monto seleccionado debe ser igual a {amount} o estar entre {min} y {max}',
        deleteReference: 'Eliminar referencia',
        deleteReferenceDescription: '¿Estás seguro de que deseas eliminar la referencia de pago?',
        downloadNote: 'Descargar nota de pago',
        numberOfContracts: 'Número de contratos',
        shops: 'Comercios:',
        walmart: 'Walmart',
        soriana: 'Soriana',
        bodegaAurrera: 'Bodega Aurrera',
        sams: 'Sam\'s',
        circleK: 'Circle K',
        mas: 'Y más...',
      },
    },
    mercadopago: {
      title: 'Pago con Mercado Pago',
      loading: 'Cargando tarjetas...',
      processing: 'Procesando pago...',
      amountLabel: 'Monto a pagar',
      addCardButton: 'Agregar tarjeta',
      processPayment: 'Procesar pago',
      selectCard: 'Selecciona una tarjeta',
      cardSelector: {
        title: 'Selecciona una tarjeta',
        defaultCardName: 'Tarjeta',
        invalidCard: 'Tarjeta inválida',
        selectButton: 'Seleccionar tarjeta',
        editButton: 'Editar tarjeta',
      },
      cardUpdated: 'Tarjeta actualizada correctamente',
      cardDeleted: 'Tarjeta eliminada correctamente',
      summary: {
        title: 'Resumen del pago',
        back: 'Volver',
        confirm: 'Confirmar pago',
        amount: 'Monto',
        holder: 'Titular',
        card: 'Tarjeta',
        installments: 'Cuotas',
        contracts: 'Contratos',
        contractNumber: 'Contrato',
        concept: 'Concepto',
        totalAmount: 'Total a pagar',
        errorTitle: 'Ha ocurrido un error.',
        errorMessage: 'Por favor, intente con otro método de pago.',
        warningTitle: 'Atención',
        recommendOtherMethodMessage: 'Recomendamos usar otro método de pago.',
        useOtherPaymentMethodButton: 'Volver a métodos de pago',
      },
      form: {
        title: 'Datos de la tarjeta',
        cardNumber: 'Número de tarjeta',
        expirationDate: 'Fecha de expiración',
        securityCode: 'Código de seguridad',
        cardholder: 'Titular de la tarjeta',
        cardholderPlaceholder: 'Titular de la tarjeta',
        saveCard: 'Guardar tarjeta para futuras compras',
        cancel: 'Cancelar',
        continue: 'Continuar',
        issuer: 'Banco emisor',
        placeholders: {
          cardNumber: 'Número de la tarjeta',
          expiration: 'MM/YY',
          securityCode: 'Código de seguridad',
        },
        errors: {
          invalidName: 'Nombre del titular inválido',
          invalidPaymentMethod: 'Por favor, ingresa un número de tarjeta válido',
          notReady: 'Mercado Pago no está listo. Por favor, intenta de nuevo.',
          tokenFailed: 'No se pudo generar el token. Por favor, verifica los datos de la tarjeta.',
          processFailed: 'Error al procesar la tarjeta',
        },
      },
      challenge: {
        title: 'Autenticación requerida',
        description: 'Por favor, completa la autenticación en la ventana a continuación para continuar con tu pago.',
        verifying: 'Challenge completado. Verificando estado del pago...',
        errors: {
          unavailable: 'Información del Challenge 3DS no disponible',
          missingCreq: 'Para completar la autenticación 3DS la respuesta del pago debe incluir el campo creq (en three_ds_info o threeDS). Revisa que tu backend devuelva la respuesta completa de la API de MercadoPago.',
          containerNotFound: 'Contenedor del Challenge no encontrado',
          initError: 'Error al inicializar el Challenge. Por favor, intenta de nuevo.',
        },
      },
      addCard: {
        title: 'Agregar nueva tarjeta',
        cardNumber: 'Número de tarjeta',
        cardholderName: 'Nombre del titular',
        cardholderNamePlaceholder: 'Nombre como aparece en la tarjeta',
        expirationMonth: 'Mes de expiración',
        expirationYear: 'Año de expiración',
        cvv: 'CVV',
        addButton: 'Agregar tarjeta',
        errors: {
          invalidCardNumber: 'Número de tarjeta inválido',
          invalidName: 'Nombre del titular inválido',
          invalidMonth: 'Mes de expiración inválido',
          invalidYear: 'Año de expiración inválido',
          invalidCvv: 'CVV inválido',
          addFailed: 'Error al agregar la tarjeta',
          tokenizationFailed: 'Error al procesar la tarjeta',
        },
      },
      cvvModal: {
        title: 'Ingresa el CVV',
        cardLabel: 'Tarjeta seleccionada',
        cvvLabel: 'Código de seguridad (CVV)',
        submitButton: 'Confirmar',
        securityCodeHint: 'Introduce el código de seguridad de la tarjeta',
        errors: {
          invalidCvv: 'CVV inválido',
          noCard: 'No se ha seleccionado una tarjeta',
          tokenFailed: 'Error al procesar la tarjeta',
        },
      },
      editCardForm: {
        title: 'Editar tarjeta',
        editingLabel: 'Editando tarjeta',
        cardNumber: 'Número de tarjeta',
        expirationDate: 'Fecha de expiración',
        securityCode: 'Código de seguridad',
        cardholder: 'Titular de la tarjeta',
        cardholderPlaceholder: 'Titular de la tarjeta',
        issuer: 'Banco emisor',
        cancel: 'Cancelar',
        saveButton: 'Guardar cambios',
        deleteButton: 'Eliminar tarjeta',
        successMessage: 'Tarjeta actualizada correctamente',
        placeholders: {
          cardNumber: 'Número de la tarjeta',
          expiration: 'MM/YY',
          securityCode: 'Código de seguridad',
        },
        errors: {
          invalidName: 'Nombre del titular inválido',
          invalidPaymentMethod: 'Por favor, ingresa un número de tarjeta válido',
          notReady: 'Mercado Pago no está listo. Por favor, intenta de nuevo.',
          tokenFailed: 'No se pudo generar el token. Por favor, verifica los datos de la tarjeta.',
          processFailed: 'Error al procesar la tarjeta',
          differentCard: 'La tarjeta ingresada no coincide con la tarjeta que estás editando.',
        },
      },
      deleteCardModal: {
        title: 'Eliminar tarjeta',
        description: '¿Estás seguro de que deseas eliminar esta tarjeta?',
        cancelButton: 'Cancelar',
        confirmButton: 'Eliminar',
        successMessage: 'Tarjeta eliminada correctamente',
      },
      errors: {
        title: 'Error',
        selectCard: 'Por favor selecciona una tarjeta',
        paymentFailed: 'Error al procesar el pago',
        rejected: 'El pago fue rechazado',
        rejected3ds: 'El pago fue rechazado después de completar la autenticación',
        expired: 'El pago expiró. Por favor, intenta de nuevo.',
        pending: 'El pago está pendiente. Por favor, espera unos momentos e intenta verificar el estado nuevamente.',
        verificationFailed: 'No se pudo verificar el estado del pago',
        verificationError: 'Error al verificar el estado del pago. Por favor, intenta más tarde.',
        challengeError: 'Error al procesar el pago. Inténtalo de nuevo.',
        paymentPendingMax: 'El pago sigue pendiente. Por favor, verifica el estado más tarde.',
        saveCardFailed: 'Error al guardar la tarjeta',
        updateCardFailed: 'Error al actualizar la tarjeta. Por favor, intenta de nuevo.',
        deleteCardFailed: 'Error al eliminar la tarjeta. Por favor, intenta de nuevo.',
      },
      /** Mensajes por status_detail de Mercado Pago (pagos no aprobados) */
      statusDetails: {
        pending_capture: 'El pago fue autorizado y está a la espera de ser capturado.',
        offline_process: 'Por una falta de procesamiento online, el pago está siendo procesado de manera offline.',
        pending_contingency: 'Estamos procesando tu pago. No te preocupes, en menos de 2 días hábiles te avisaremos por correo si se acreditó.',
        pending_review_manual: 'Estamos procesando tu pago. No te preocupes, en menos de 2 días hábiles te avisaremos por correo si se acreditó o si necesitamos más información.',
        pending_waiting_transfer: 'Estamos esperando a que completes el proceso de pago en tu banco (transferencia).',
        pending_waiting_payment: 'El pago queda pendiente hasta que realices el pago.',
        pending_challenge: 'Hay una confirmación pendiente por autenticación. Completa el proceso en la ventana indicada.',
        bank_error: 'El pago fue rechazado por un error con el banco.',
        cc_rejected_3ds_mandatory: 'El pago fue rechazado. Por favor, inténtalo de nuevo con otro método de pago.',
        cc_rejected_bad_filled_card_number: 'Revisa el número de tarjeta.',
        cc_rejected_bad_filled_date: 'Revisa la fecha de vencimiento.',
        cc_rejected_bad_filled_other: 'Revisa los datos ingresados.',
        cc_rejected_bad_filled_security_code: 'Revisa el código de seguridad de la tarjeta.',
        cc_rejected_blacklist: 'No pudimos procesar tu pago.',
        cc_rejected_call_for_authorize: 'Debes autorizar el pago con tu banco o medio de pago.',
        cc_rejected_card_disabled: 'Tu tarjeta está deshabilitada. Llama a tu banco para activarla o usa otro medio de pago.',
        cc_rejected_card_error: 'No pudimos procesar tu pago.',
        cc_rejected_duplicated_payment: 'Ya hiciste un pago por ese valor. Si necesitas volver a pagar, usa otra tarjeta u otro medio de pago.',
        cc_rejected_high_risk: 'Tu pago fue rechazado. Te recomendamos usar otro medio de pago, por ejemplo efectivo.',
        cc_rejected_insufficient_amount: 'Tu tarjeta no tiene fondos suficientes.',
        cc_rejected_invalid_installments: 'Tu medio de pago no procesa pagos en el número de cuotas seleccionado.',
        cc_rejected_max_attempts: 'Llegaste al límite de intentos permitidos. Elige otra tarjeta u otro medio de pago.',
        cc_rejected_other_reason: 'Tu medio de pago no procesó el pago.',
        cc_amount_rate_limit_exceeded: 'El pago fue rechazado porque superó el límite permitido del medio de pago.',
        rejected_insufficient_data: 'El pago fue rechazado por falta de información obligatoria.',
        rejected_by_bank: 'Operación rechazada por el banco.',
        rejected_by_regulations: 'Pago rechazado por regulaciones.',
        insufficient_amount: 'Pago rechazado por montos insuficientes.',
      },
      success: {
        title: 'Pago exitoso',
        description: 'Tu pago se ha procesado correctamente',
      },
      common: {
        cancel: 'Cancelar',
        continue: 'Continuar',
      },
    },
    registration: {
      start: {
        areYouAClient: '¿Ya eres cliente?',
        ifYouAlreadyAreAClient: 'Introduce tu número de cliente o INE',
        whereClientNumber: '¿Dónde encuentro mi No. de cliente?',
        pawnContract: 'Contrato de empeño',
        apartContract: 'Contrato de apartado',
        ifYouAreNotAClient: 'Si aún no eres cliente',
        makeYourRegistration: 'Hazte cliente',
        tenDigits: '10 dígitos',
        errors: {
          userAlreadyExists: 'Ya existe una cuenta en la aplicación con estos datos, por favor inicia sesión',
          incompleteData: 'Tu usuario no tiene datos suficientes para darte de alta. Favor de acudir a la oficina más cercana para informarlo.',
          serviceUnavailable: 'El servicio no está disponible en este momento. Por favor, intenta de nuevo más tarde.',
          userNotFound: 'No se encontró ningún cliente con esos datos.',
        },
      },
      basicInfo: {
        letsStart: 'Empecemos...',
        personalData: 'Datos personales',
        yourFullName: '¿Cuál es tu nombre completo?*',
        firstName: 'Primer nombre',
        lastName: 'Segundo nombre',
        paternal: 'Apellido paterno',
        maternal: 'Apellido materno',
        gender: 'Género',
        male: 'Masculino',
        female: 'Femenino',
        yourEmail: '¿Cuál es tu correo electrónico?*',
        yourPhone: '¿Cuál es tu número celular?*',
        email: 'Correo',
        phone: 'Número celular',
        referralCode: 'Código de referido (opcional)',
        referralCodePlaceholder: 'ABCD1234567',
        referralCodeHelper: 'Si alguien te invitó, ingresa aquí el código que te compartió.',
        acceptPrivacy: 'He leído y acepto el Aviso de Privacidad',
        privacyPolicy: 'Aviso de Privacidad',
        acceptApp: 'He leído y acepto los Términos y Condiciones de la App MLS',
        termsAndConditions: 'Términos y Condiciones',
        errors: {
          RECHAZADO: 'El correo fue rechazo por el servidor SMTP. (I-1)',
          DOMINIO_INVALIDO: 'El dominio no existe, validar de nuevo. (I-2)',
          CORREO_INVALIDO: 'El correo ingresado no es válido. (I-3)',
          SMTP_INVALIDO: 'El servidor SMTP no responde, intentar más tarde. (I-4)',
          ERROR_EN_ESCRITURA: 'La estructura del correo no es válida. (1-5)',
          EN_LISTA_DE_BLOQUEO: 'El correo ingresado esta bloqueado, intentar con otro. (I-6)',
          NO_SE_ACEPTAN_CORREOS: 'El correo ingresado solo realiza envió y no recibe. (I-7)',
          SINTAXIS_INVALIDA: 'La estructura del correo no es válida con las reglas RFC. (I-8)',
          HA_SUPERADO_LA_CUOTA_DE_BUZON: 'El correo ingresado tiene el buzón lleno, favor de liberar espacio o ingresar uno nuevo. (I-9)',
          DIRECCION_DE_CORREO_NO_ENCONTRADA: 'La estructura es correcta pero el correo no es válido, intentar uno valido. (I-10)',
          SIN_ENTRADA_DNS: 'El dominio del correo no tiene un registro en DNS. (I-11)',
          POSIBLE_ERROR_ESCRITURA: 'Revisar la escritura del dominio ingresado. (1-12)',
          DIRECCION_IP_NO_ENRUTABLE: 'Revisar con el proveedor del dominio, la disponibilidad de los servicios (I-13)',
          BAJA_CALIDAD: 'El correo electrónico es vulnerable, intentar con otro. (R-14)',
          BAJA_ENTREGABILIDAD: 'El correo electrónico no tiene la garantía que se reciban los correos, intentar con otro. (R-15)',
          LISTA_BLOQUEO_GLOBAL: 'El correo electrónico se encuentra en listas negras, favor de intentar con otro. (R-16)',
          POSIBLE_TRAMPA: 'El correo electrónico puede ser posible SPAM, favor de intentar con otro. (R-17)',
          DIRECCION_ROL: 'El correo ingresado se detecto como contact center, intentar con otro. (R18)',
          DIRECCION_ROL_ACEPTA_TODO: 'El correo electrónico ingresado se detectó como riesgoso, favor de intentar con otro. (R-19)',
          DIRECCION_DESECHABLE: 'Se detecto un correo electrónico temporal, favor de intentar con otro. (R-20)',
          DIRECCION_TOXICA: 'El correo electrónico ingresado se detectó como riesgoso, favor de intentar con otro. (R-21)',
          SIN_CONEXION: 'Por el momento no se pudo conectar al servidor para la validación del correo electrónico, favor de intentar más tarde. (D-22)',
          NO_RESPONDE: 'Por el momento no se puede realizar la validación del correo electrónico, favor de reportarlo con atención al cliente. (D-23)',
          SMTP_NO_DISPONIBLE: 'La validación del correo electrónico no se puede realizar en este momento, intentar más tarde. (D-24)',
          ERROR_INESPERADO: 'Ocurrió un error inesperado para la validación del correo electrónico, intentar más tarde. (D-25)',
          TEMPORALMENTE_FUERA_DE_SERVICIO: 'La validación del correo electrónico no se puede realizar en este momento, intentar más tarde. (D-26)',
          FILTRO_ANTI_SPAM_ACTIVADO: 'No se pudo realizar la validación del correo electrónico, favor de intentar con otro. (D-27)',
          OCURRIO_UNA_EXCEPCION: 'La validación de correo provoco una excepción. (D-28)',
          FALLO_CONEXION_SMTP: 'No se pudo validar el correo electrónico por falta de conexión con al servidor de este, intentar más tarde. (D-29)',
          DESCONEXION_SERVIDOR: 'El correo electrónico ingresado no tiene una conexión estable, favor de intentar con otro. (D-30)',
          TEMPORALMENTE_NO_VALIDABLE: 'El correo electrónico ingresado por el momento no se puede validar, favor de intentar más tarde. (D-31)',
          SERVIDOR_SMTP_NO_RESPONDE: 'El correo ingresado no responde para su validación, intentar más tarde. (D-32)',
          SERVIDOR_SMTP_NO_DISPONIBLE: 'El correo ingresado no está disponible para su validación, intentar más tarde. (D-33)',
          TIEMPO_DE_ESPERA_EXCEDIDO: 'El servidor del correo electrónico excedió el tiempo de respuesta, intentar más tarde. (D-34)',
          REFERRAL_CODE_INVQLID_LENGTH: 'El código de referido debe tener 11 caracteres.',
          REFERRAL_CODE_INVALID_LENGTH: 'El código de referido debe tener 11 caracteres.',
          REFERRAL_CODE_INVALID_FORMAT: 'El código de referido debe tener 4 letras y 7 números.',
          invalidReferralCode: 'El código de referido no tiene un formato válido.',
        },
      },
      existsOTPValidation: {
        verifyAccount: 'Vamos a verificar tu cuenta',
        verifyAccountDescription: 'Hemos identificado una cuenta de cliente con los datos que nos has proporcionado. <br /><br />Selecciona donde quieres que te enviemos el código de verificación para asociar tu cuenta con nuestra aplicación.',
        noData: 'No se han encontrado datos de contacto para enviar el código de verificación, por favor ponte en contacto con soporte para que te podamos ayudar.',
        errors: {
          invalidOTP: 'El código de verificación es inválido, por favor intentalo de nuevo',
        },
      },
      OTPValidation: {
        smsVerification: 'Verificación SMS',
        smsVerificationDescription: 'Recibirás un código de verificación mediante un SMS al número: <b>{phone}</b>.',
        whatsappVerification: 'Verificación por WhatsApp',
        whatsappVerificationDescription: 'Recibirás un código de verificación por WhatsApp al número: <b>{phone}</b>.',
        sendBySms: 'Enviar por SMS',
        smsFallbackSuccess: 'No pudimos usar WhatsApp. Te enviamos el código por SMS.',
        refreshCode: 'Ingresa el nuevo código para continuar. No hace falta repetir la validación de identidad.',
        itsNotMyPhone: 'No es mi número de celular',
        codeExpirationTime: 'Vigencia del código',
        notReceivedCode: 'No he recibido el código',
        emailVerification: 'Verificación EMAIL',
        emailVerificationDescription: 'Recibirás un código de verificación por correo electrónico a <b>{email}</b>.',
        itsNotMyEmail: 'No es mi correo electrónico',
        resendCode: 'Reenviar código',
        confirmResend: '¿Estás seguro de que deseas reenviar el código? Puede que los envios se demoren unos segundos',
        resend: 'Reenviar',
        waitToSendCode: 'Debes esperar {time} segundos para poder solicitar otro código',
        resendSuccess: '¡Reenviado!',
        resendCodeSuccess: 'El código ha sido reenviado correctamente, si continuas sin recibirlo revisa que la información que ingresaste es correcta o espera unos segundos más (el envio puede demorarse según el proveedor de servicios).',
        errorResend: 'Ha ocurrido un error al reenviar el código, por favor intentalo de nuevo',
      },
      password: {
        createPassword: 'Crea tu contraseña',
        passwordCreated: 'Contraseña creada',
        useInApp: 'Esta contraseña es la que usarás para acceder a la aplicación, debe cumplir con los siguientes requisitos:',
        password: 'Contraseña',
        repeatPassword: 'Repite tu contraseña',
        confirmPassword: 'Confirmar contraseña',
        yourPasswordMust: 'Tu contraseña debe tener:',
        linkBiometric: 'Vincular biométricos del dispositivo',
        yourRegistrationEmail: 'Para confirmar tu cuenta, introduce el correo electrónico con el que iniciaste el proceso de registro',
        passwordSavedButInvalidEmail: 'La contraseña se guardó correctamente pero el correo electrónico ingresado no es el mismo con el que te registraste, por favor revisalo e intenta de nuevo',
        continueRegistrationEmail: 'La contraseña se ha vinculado a tu cuenta, pero necesitamos que introduzcas el correo electrónico con el que te registraste para poder continuar con el registro',
      },
      successBasic: {
        subtitle: 'Ya formas parte de',
        descriptionTitle: 'Tu cuenta ya existe',
        description: 'Tu cuenta ya está creada.\n\n Completar el resto de la información se hará en un paso aparte.\n\n Tu número de cliente es <b>{clientId}</b>',
        continue: 'Completar registro',
        finishLater: 'Terminar más tarde',
        finish: 'Ir al inicio',
      },
      successBasicLinked: {
        subtitle: 'Tu cuenta de cliente ha sido dada de alta en la aplicación.',
        descriptionTitle: 'Tu cuenta ya existe',
        description: 'Tu cuenta ya está vinculada.\n\n Completar el resto de la información se hará en un paso aparte.\n\n Recuerda que tu número de cliente es <b>{clientId}</b>',
        continue: 'Completar registro',
        finishLater: 'Terminar más tarde',
        finish: 'Ir al inicio',
      },
      verification: {
        verifyIdentity: 'Validación de identidad',
        prepareYourIdentity: 'Prepara tus documentos',
        cameraPermissions: 'Autorizo el uso de la cámara',
        errorCameraPermissions: 'No se ha podido obtener el permiso de cámara, por favor revisa los permisos de tu dispositivo e intentalo de nuevo',
        errorCameraPermissionsBrowser: 'Para verificar tu identidad necesitamos acceso a la cámara. Permite el acceso desde la configuración de tu navegador (candado en la barra de direcciones) y vuelve a intentarlo. Si no puedes habilitar la cámara, descarga la app para continuar.',
        locationPermissions: 'Autorizo compartir ubicación',
        errorLocationPermissions: 'No se ha podido obtener el permiso de ubicación, por favor revisa los permisos de tu dispositivo e intentalo de nuevo',
        scanInfo: 'A continuación vamos a capturar:',
        scanDocument: 'Tu documento de identificación vigente (INE o Pasaporte)',
        scanFace: 'Una foto "selfie" de tu rostro',
        scanProofOfAddress: 'Tu comprobante de domicilio con vigencia de 4 meses (recibo de luz, teléfono, agua, predial o gas)',
        scanInfo2: 'Descuida, esta información está protegida y segura, solo la utilizaremos para validar tu identidad y completar tu registro.',
        weRecommend: 'Te recomendamos:',
        clearLocation: 'Estar en un lugar bien iluminado',
        avoidShadows: 'Evitar sombras y reflejos',
        keepFaceVisible: 'Mantén tu rostro descubierto y evita el uso de lentes, gorras o cubrebocas',
        adjustINE: 'Posiciona tus documentos y rostro dentro del marco que verás en pantalla y sigue las instrucciones',
        errorIdMissionCancel: 'Se ha cancelado el proceso de verificación, por favor intentalo de nuevo',
        errorIdMissionSession: 'Ha ocurrido un error al iniciar el proceso de verificación, por favor intentalo de nuevo',
        errorIdMissionFailure: 'Ha ocurrido un error durante el proceso de verificación, por favor revisa las instrucciones y vuelve a intentarlo',
        errorsIDMission: {
          Decision_KeyComponent: 'No se pudo validar tu documento, por favor intenta de nuevo (KC001)',
          Decision_DataMatch: 'Los datos de tu documento no coinciden con los datos del cliente, por favor intenta de nuevo (DM002)',
          Decision_ImageQuality: 'La calidad de la imagen no es suficiente para validar tu documento, por favor intenta de nuevo (IQ003)',
          Decision_MRZ: 'No se pudo extraer la información de tu documento, por favor intenta de nuevo (MRZ004)',
          Decision_SecurityFeature: 'No se pudo validar tu documento de acuerdo a los estandares de seguridad, por favor intenta de nuevo (SF005)',
          Decision_ColorCode: 'No se pudo validar tu documento de acuerdo a los estandares de color, por favor intenta de nuevo (CC006)',
          Decision_Sample: 'No se pudo validar tu documento, por favor intenta de nuevo (SP007)',
          Decision_FaceDetected: 'No se pudo verificar la imagen facial, por favor intenta de nuevo (FD008)',
          Decision_AgeValidation: 'No se pudo validar la edad, por favor intenta de nuevo (AV009)',
          Decision_FaceMatch: 'El resultado de la comprobación de la imagen facial no coincide con la imagen del documento, por favor intenta de nuevo (FM010)',
          Decision_Tamper: 'No se ha podido asegurar la validez del documento. Asegúrate de estar utilizando el documento oficial original, por favor intenta de nuevo (T011)',
          Decision_IDaccepted: 'Su documento no ha sido aceptado, por favor intenta de nuevo (IA012)',
          Decision_SuspiciousID: 'Su documento ha sido detectado como sospechosa, por favor intenta de nuevo (SI013)',
          Decision_TemplateMatch: 'No se pudo validar tu documento, por favor intenta de nuevo (TM014)',
          Decision_Expiration: 'No se ha podido validar la fecha de expiración de tu documento, por favor intenta de nuevo (E015)',
          Decision_Liveness: 'No se ha podido validar la prueba de vida en la selfie, por favor intenta de nuevo (L016)',
          Decision_Deduplication: 'Ya existe un cliente con el documento proporcionado, por favor intenta de nuevo (DD017)',
          Generic: 'No se pudo validar tu documento, por favor intenta de nuevo (GN017)',
          Generic2: 'No se pudo validar tu documento, por favor intenta de nuevo (GN017-2)',
          InvalidData: 'No se han podido extraer los datos básicos de tu documento, por favor intenta de nuevo (DT018)',
        },
      },
      validateData: {
        validateData: 'Valida tus datos',
        checkData: 'Revisa que tus datos sean correctos, si notas algún error puedes repetir la captura de tus documentos.',
        id: 'Número de Identificación',
        CURP: 'CURP',
        names: 'Nombre(s)',
        lastNames: 'Apellido(s)',
        birthDate: 'Fecha de nacimiento',
        gender: 'Sexo',
        electoral: 'Clave elector',
        helpToKnowYou: 'Ayúdanos a conocerte mejor',
        whatsYourJob: 'Actividad económica',
        howDidYouHear: '¿Cómo se enteró de nosotros?',
        educationLevel: '¿Nivel de estudios?',
        captureAgain: 'Capturar nuevamente',
        additionalInfo: 'Información adicional',
        selectOneOption: 'Selecciona una opción',
        citizenship: 'Nacionalidad',
        countryOfBirth: 'Pais de nacimiento',
        collectionsError: 'Ha ocurrido un error al cargar las opciones, por favor intentalo de nuevo más tarde',
        genders: {
          VID: { M: 'Mujer', H: 'Hombre' },
          PP: { M: 'Masculino', F: 'Femenino' },
        },
      },
      address: {
        validateAddress: 'Valida tu domicilio',
        checkAddress: 'Revisa que sea tu domicilio actual, de lo contrario puedes ingresarlo manualmente.',
        writeYourPostalCode: 'Ingresa el Código Postal de tu domicilio actual',
        validate: 'Validar',
        address: 'Dirección',
        itsMyAddress: 'Es mi domicilio',
        itsNotMyAddress: 'No es mi domicilio',
        addYourAddress: 'Añade tu domicilio',
        invalidAddress: 'No hemos podido extraer los datos completos de tu domicilio, a continuación puedes ingresar manualmente los datos que falten.',
        country: 'País',
        state: 'Entidad Federativa',
        city: 'Alcaldía/Municipio',
        postalCode: 'Código Postal',
        neighborhood: 'Colonia',
        street: 'Calle',
        number: 'Número',
        internalNumber: 'Número interior (opcional)',
        confirmNumber: 'Confirma el número',
        confirmNeighborhood: 'Confirma la colonia',
        adressValidation: 'Comprobante de domicilio',
        openCamera: 'Abrir cámara',
        uploadFile: 'Subir archivo',
        uploadAddressValidation: 'Toma una foto de tu comprobante de domicilio con vigencia de 4 meses (recibo de luz, teléfono, agua, predial o gas)',
        takePicture: 'Tomar foto',
        otherNeighborhood: '*Ninguna de las anteriores',
        writeNeighborhood: 'Escribe la colonia',
        theAddressIsCorrect: 'La dirección es correcta',
        errorPostalCodeLength: 'El código postal debe tener 5 dígitos',
        postalCodeNotFound: 'El código postal {postalCode} no se ha encontrado, por favor revisa los datos e intenta de nuevo',
      },
      successComplete: {
        subtitle: 'Has completado el registro',
        descriptionTitle: '',
        description: 'Ahora podrás <b>acceder a todas las ventajas</b> que te ofrece MLS App sin restricciones.\n\n Tu número de cliente es <b>{clientId}</b> ¡Esperamos que disfrutes de la experiencia!',
        welcomeBonus: 'Se acreditaron {points} puntos de bienvenida',
        continue: 'Finalizar',
      },
      congratulations: '¡Felicidades!',
      confirmExit: '¿Estás seguro de querer abandonar el registro?',
      goToLogin: 'Ir a iniciar sesión',
      goToRecoverPassword: 'Ir a recuperar contraseña',
      goToLinkAccount: 'Vincular cuenta',
      errorSendingOTP: 'Ha ocurrido un error al enviar el código de verificación, por favor intentalo de nuevo',
      contactSupport: 'Contactar a soporte',
    },
    appointment: {
      successTitle: 'Cita registrada correctamente',
      notificationTitle: 'Cita agendada',
      notificationBody: 'Tu cita ha sido agendada con éxito',
      office: 'Sucursal',
      address: 'Dirección',
      date: 'Fecha',
      selectOffice: 'Selecciona una sucursal',
      scripts: {
        First_Name: 'Nombre*',
        Last_Name: 'Apellido*',
        reset: 'Restablecer',
        submit: 'Enviar',
      },
    },
    klu: {
      permissions: 'Autorización de permisos',
      beforeContinue: 'Antes de continuar, necesitamos que revises los siguientes permisos con el fin de que puedas continuar con el proceso de registro en KLU.',
      beforeContinueSingle: 'Antes de continuar, necesitamos que revises el siguiente permiso con el fin de que puedas continuar a KLU.',
      locationPermissions: 'Autorizo el acceso a ubicación',
      cameraPermissions: 'Autorizo el acceso a cámara',
      locationDescription: 'En cumplimiento a las disposiciones de la CNBV y para tu seguridad es necesario obtener la <b>localización de tu dispositivo</b>.',
      cameraDescription: 'Durante el proceso de registro en KLU se utilizará la <b>cámara de tu dispositivo</b> con el fin de verificar tu identidad.',
      errorLocationPermissions: 'No se ha podido obtener el permiso de ubicación, por favor revisa los permisos de tu dispositivo e intentalo de nuevo',
      errorCameraPermissions: 'No se ha podido obtener el permiso de cámara, por favor revisa los permisos de tu dispositivo e intentalo de nuevo',
      errorCameraPermissionsBrowser: 'Para usar KLU necesitamos acceso a la cámara. Permite el acceso desde la configuración de tu navegador (candado en la barra de direcciones) y vuelve a intentarlo. Si no puedes habilitar la cámara, descarga la app para continuar.',
      documentValidation: {
        title: 'Preparación para el proceso',
        description: 'Para continuar con tu registro en KLU, asegúrate de contar con lo siguiente:',
        ine: 'Tengo mi INE (Identificación oficial) a la mano',
        rfc: 'Tengo mi RFC con homoclave disponible',
        proofOfAddress: 'Tengo mi comprobante de domicilio listo',
        googleAuthenticator: 'Tengo Google Authenticator instalado en mi dispositivo',
        continue: 'Continuar',
        cancel: 'Cancelar',
      },
    },
    pageError: {
      title500: 'Lo sentimos, ha ocurrido un error inesperado',
      description500: 'Nuestro equipo ha sido informado del problema. Pedimos disculpas por las molestias.',
      title404: 'Lo sentimos, la página que buscas no existe',
      title401: 'Lo sentimos, no estás autorizado para ver esta página',
      title400: 'Lo sentimos, ha ocurrido un error en la solicitud',
      unknownStatus: 'The status returned is unknown and has not been handled',
      back: 'Volver al inicio',
    },
    notFound: {
      title: '¡Vaya!',
      description: 'No encontramos lo que buscas',
      backToHome: 'Volver a la página principal',
    },
    errors: {
      error: 'Error',
      unknown: 'Ha ocurrido un error desconocido',
      400: 'La solicitud no es válida',
      401: 'No estás autorizado para realizar esta acción',
      404: 'No se encuentra el recurso solicitado',
      500: 'Ha ocurrido un error inesperado',
      unknownUserOrPassword: 'Usuario o contraseña incorrectos',
      fileNotFound: 'Archivo no encontrado',
      default: 'Ha ocurrido un error, por favor revisa los datos e intenta de nuevo',
      ERROR_LOADING_DATA: 'Ha ocurrido un error al cargar los datos, por favor intentalo de nuevo',
      CLIENT_NOT_ASSOCIATED: 'No se pudo completar el registro de esta cuenta.',
      CLIENT_NOT_FOUND: 'No encontramos el cliente para completar el registro.',
      ONBOARDING_VALIDATION: 'Revisa los datos e intenta de nuevo.',
      ERROR_SENDING_EMAIL: 'Se ha producido un error al enviar el email',
      ERROR_SENDING_SMS: 'Se ha producido un error al enviar el SMS',
      ERROR_CREATING_EMAIL_OTP: 'Se ha producido un error al generar el código de confirmación',
      ERROR_CREATING_PHONE_OTP: 'Se ha producido un error al generar el código de confirmación SMS',
      OTP_NOT_MATCH: 'Los códigos de confirmación no coinciden',
      OTP_EMAIL_NOT_MATCH: 'El código de confirmación del email no coincide',
      OTP_PHONE_NOT_MATCH: 'El código de confirmación del celular no coincide',
      OTP_PHONE_LOCKED: 'El código de confirmación del celular se bloqueó por intentos fallidos. Solicita un código nuevo para continuar.',
      OTP_EMAIL_LOCKED: 'El código de confirmación del email se bloqueó por intentos fallidos. Solicita un código nuevo para continuar.',
      remainingAttempts: 'Intentos restantes: {remaining}.',
      USER_ALREADY_EXISTS: 'Ya existe una cuenta en la aplicación con estos datos, por favor inicia sesión',
      EMAIL_ALREADY_EXISTS: 'Ya existe una cuenta con estos datos. Inicia sesión o recupera tu acceso.',
      PHONE_ALREADY_EXISTS: 'Ya existe una cuenta con estos datos. Inicia sesión o recupera tu acceso.',
      PHONE_ALREADY_EXISTS_IN_SAP: 'Ya existe un cliente con este número de teléfono, para crear tu usuario en la aplicación debes vincular tu cuenta con tu INE o número de cliente Montepío.',
      EMAIL_ALREADY_EXISTS_IN_SAP: 'Ya existe un cliente con este correo electrónico, para crear tu usuario en la aplicación debes vincular tu cuenta con tu INE o número de cliente Montepío.',
      RFC_ALREADY_EXISTS: 'Ya existe una cuenta en la aplicación con este RFC',
      OTP_PHONE_EXPIRED: 'El código de confirmación del celular ha expirado, por favor solicita otro código',
      OTP_EMAIL_EXPIRED: 'El código de confirmación del email ha expirado, por favor solicita otro código',
      ERROR_CREATING_USER: 'Ha ocurrido un error al crear el usuario, por favor intentalo de nuevo',
      ERROR_CREATING_SAP_CLIENT: 'No se pudo crear el cliente. Tus datos se conservan, puedes intentar de nuevo.',
      ERROR_RETRIEVING_CREATED_SAP_CLIENT: 'No se pudo recuperar el cliente creado. Tus datos se conservan, puedes intentar de nuevo.',
      ERROR_SENDING_WHATSAPP: 'No pudimos enviarte el código por WhatsApp. Puedes intentar por SMS.',
      GENDER_REQUIRED: 'El género es obligatorio para crear la cuenta.',
      REFERRAL_CODE_INVALID_LENGTH: 'El código de referido debe tener 11 caracteres.',
      REFERRAL_CODE_INVQLID_LENGTH: 'El código de referido debe tener 11 caracteres.',
      REFERRAL_CODE_INVALID_FORMAT: 'El código de referido debe tener 4 letras y 7 números.',
      invalidReferralCode: 'El código de referido no tiene un formato válido.',
      ERROR_CHECKING_EMAIL: 'Ha ocurrido un error al verificar el correo electrónico, por favor intentalo de nuevo',
      INVALID_PASSWORD_TOKEN: 'El enlace para continuar el registro ha caducado, por favor solicita uno desde la recuperación de contraseña en el inicio de sesión',
    },
    select: {
      selectOneOption: 'Selecciona una opción',
    },
    input: {
      openCamera: 'Abrir cámara',
      uploadedImage: 'Imagen cargada correctamente',
    },
    maintenance: {
      title: 'Mantenimiento',
      description: 'Estamos realizando mejoras en nuestra aplicación, por favor intentalo de nuevo más tarde',
    },
    updateApp: {
      title: 'Nueva versión',
      description: 'Es necesario que actualices la aplicación para continuar usandola',
    },
    zohoForm: {
      First_Name: 'Nombre*',
      Last_Name: 'Apellido*',
      reset: 'Restablecer',
      submit: 'Enviar',
      formSent: 'Formulario enviado',
      formSentError: 'Ha ocurrido un error al enviar el formulario, por favor intentalo de nuevo',
      mandatoryField: 'El campo "{field}" es obligatorio',
      invalidEmail: 'El email introducido en el campo "{field}" no es válido',
      invalidPhone: 'El teléfono introducido en el campo "{field}" no es válido, debe tener 10 carácteres numéricos',
    },
    cmsPopups: {
      contractExpiration: {
        CONTRACT: '* Contrato: <b>{id}</b> con vencimiento al <b>{date}</b>',
        SECTION: '* Apartado: <b>{id}</b> con vencimiento al <b>{date}</b>',
      },
    },
    gestopago: {
      error: 'Ha ocurrido un error al cargar la página, por favor intentalo de nuevo más tarde',
    },
    notifications: {
      title: 'Notificaciones',
      sectionTitle: 'Notificaciones',
      searchNotifications: 'Buscar notificaciones',
      searchPlaceholder: 'Buscar por título o contenido',
      category: 'Categoría',
      importantMessages: 'Mensajes importantes',
      movements: 'Movimientos',
      notices: 'Avisos',
      promotions: 'Promociones',
      search: 'Buscar',
      clearFilters: 'Borrar filtros',
      noNotifications: 'No tienes notificaciones',
      noResults: 'No hay notificaciones con esos filtros',
      loadError: 'No se pudieron cargar las notificaciones.',
      unavailable: 'La notificación no está disponible.',
      forbidden: 'No tienes permiso para ver las notificaciones.',
      loadMore: 'Cargar más',
      loading: 'Cargando',
    },
    common: {
      loading: 'Cargando...',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      yes: 'Sí',
      no: 'No',
      error: 'Error',
      success: 'Éxito',
      warning: 'Advertencia',
      info: 'Información',
      close: 'Cerrar',
      accept: 'Aceptar',
      reject: 'Rechazar',
      save: 'Guardar',
      edit: 'Editar',
      delete: 'Eliminar',
      add: 'Añadir',
      search: 'Buscar',
      searching: 'Buscando...',
      filter: 'Filtrar',
      clear: 'Limpiar',
      next: 'Siguiente',
      previous: 'Anterior',
      back: 'Volver',
      finish: 'Finalizar',
      send: 'Enviar',
      continue: 'Continuar',
      finalize: 'Finalizar',
      favorite: 'Favorito',
      goBack: 'Volver',
      retry: 'Reintentar',
      ine: 'INE',
      clientNumber: 'Número de cliente',
      phone: 'Número celular',
      landline: 'Número fijo',
      product: 'Producto',
      name: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      state: 'Estado',
      reset: 'Restablecer',
      telephone: 'Teléfono',
      page: 'Página',
      download: 'Descargar',
      viewAll: 'Ver todos',
      contract: 'Contrato',
      section: 'Apartado',
      amount: 'Monto',
      minAmount: 'Monto mínimo',
      maxAmount: 'Monto máximo',
      month: 'mes',
      months: 'meses',
      showDetails: 'Mostrar detalles',
      passwordRequirements: 'La contraseña debe tener al menos 10 caracteres y no puedes repetir las anteriores',
      genericError: 'Ha ocurrido un error, por favor intenta de nuevo',
      outOfHour: 'Lo sentimos, esta opción no está disponible en este momento ({now} Ciudad de México). El horario para poder realizar pagos es el siguiente:',
      amountRangeErrorWithOriginal: 'El monto seleccionado debe ser igual a {amount} o estar entre {min} y {max}',
      amountRangeError: 'El monto seleccionado debe estar entre {min} y {max}',
      days: {
        0: 'Lunes',
        1: 'Martes',
        2: 'Miércoles',
        3: 'Jueves',
        4: 'Viernes',
        5: 'Sábado',
        6: 'Domingo',
      },
      noAccount: '¿Aún no tienes cuenta?',
      registerHere: '¡Registrate aquí!',
      share: 'Compartir',
      total: 'Total',
      haveKluAccount: 'Ya he iniciado mi registro en KLU',
    },
  },
};
